import * as i0 from '@angular/core';
import { EventEmitter, Injectable, Inject, Component, Input, Pipe, ViewChild, Output, Directive, NgModule } from '@angular/core';
import { Subscription } from 'rxjs';
import * as i1 from '@angular/material/snack-bar';
import { MatSnackBarConfig, MatSnackBarModule } from '@angular/material/snack-bar';
import * as i1$2 from '@angular/forms';
import { FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i1$1 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i2 from '@angular/platform-browser';
import * as i3$1 from '@angular/router';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import { trigger, transition, style, animate } from '@angular/animations';
import * as i4 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i6 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i7 from 'ngx-mask';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import * as i8 from '@angular/material/select';
import { MatSelectModule } from '@angular/material/select';
import * as i6$1 from '@angular/material/core';
import * as i10 from '@angular/material/progress-spinner';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import * as i11 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import { startWith, map } from 'rxjs/operators';
import * as i5 from '@angular/material/autocomplete';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import * as i9 from 'ngx-currency';
import { NgxCurrencyDirective } from 'ngx-currency';
import * as i13 from '@angular/material/chips';
import { MatChipsModule } from '@angular/material/chips';
import * as i9$1 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatRadioModule } from '@angular/material/radio';

class ConstantFormVida {
    // OPTIONS SELECTS
    static sexo = [
        { value: 'F', viewValue: 'Feminino' },
        { value: 'M', viewValue: 'Masculino' }
    ];
    static estadoCivil = [
        { value: 1, viewValue: 'Solteiro(a)' },
        { value: 2, viewValue: 'Casado(a)' },
        { value: 3, viewValue: 'Separado(a)' },
        { value: 4, viewValue: 'Divorciado(a)' },
        { value: 5, viewValue: 'Viúvo(a)' },
        { value: 6, viewValue: 'União Estável' }
    ];
    static simOuNao = [
        { value: true, viewValue: 'Sim' },
        { value: false, viewValue: 'Não' }
    ];
    static profissoes = [
        {
            "value": 129,
            "viewValue": "Administrador"
        },
        {
            "value": 134,
            "viewValue": "Administrador de empresas"
        },
        {
            "value": 0,
            "viewValue": "Advogado (direito penal / criminalista)"
        },
        {
            "value": 1,
            "viewValue": "Advogado (exceto advogado do direito penal / criminalista)"
        },
        {
            "value": 2,
            "viewValue": "Alfaiate"
        },
        {
            "value": 126,
            "viewValue": "Analista de automação"
        },
        {
            "value": 3,
            "viewValue": "Antropólogo"
        },
        {
            "value": 4,
            "viewValue": "Aposentado por invalidez (exceto funcionário público)"
        },
        {
            "value": 6,
            "viewValue": "Aposentado por invalidez (funcionário público)"
        },
        {
            "value": 5,
            "viewValue": "Aposentado por tempo de serviço (exceto funcionário público)"
        },
        {
            "value": 7,
            "viewValue": "Aposentado por tempo de serviço (funcionário público)"
        },
        {
            "value": 8,
            "viewValue": "Arqueólogo"
        },
        {
            "value": 9,
            "viewValue": "Arquiteto"
        },
        {
            "value": 10,
            "viewValue": "Astrólogo"
        },
        {
            "value": 11,
            "viewValue": "Astrônomo"
        },
        {
            "value": 12,
            "viewValue": "Atendente ou recepcionista"
        },
        {
            "value": 13,
            "viewValue": "Atleta profissional (outras modalidades)"
        },
        {
            "value": 14,
            "viewValue": "Atleta profissional de futebol"
        },
        {
            "value": 15,
            "viewValue": "Atleta profissional de golfe"
        },
        {
            "value": 16,
            "viewValue": "Atleta profissional de hoquei"
        },
        {
            "value": 17,
            "viewValue": "Atleta profissional de luta"
        },
        {
            "value": 18,
            "viewValue": "Atleta profissional de rugbi"
        },
        {
            "value": 19,
            "viewValue": "Atleta profissional de tenis"
        },
        {
            "value": 20,
            "viewValue": "Atleta profissional de vôlei"
        },
        {
            "value": 21,
            "viewValue": "Ator"
        },
        {
            "value": 22,
            "viewValue": "Auxiliar administrativo"
        },
        {
            "value": 124,
            "viewValue": "Auxiliar de limpeza"
        },
        {
            "value": 123,
            "viewValue": "Auxiliar geral"
        },
        {
            "value": 23,
            "viewValue": "Auxiliar ou técnico de enfermagem"
        },
        {
            "value": 24,
            "viewValue": "Barbeiro"
        },
        {
            "value": 25,
            "viewValue": "Barman"
        },
        {
            "value": 26,
            "viewValue": "Bibliotecário"
        },
        {
            "value": 27,
            "viewValue": "Biomédico"
        },
        {
            "value": 28,
            "viewValue": "Biólogo"
        },
        {
            "value": 30,
            "viewValue": "Bombeiro militar (cabo)"
        },
        {
            "value": 34,
            "viewValue": "Bombeiro militar (capitao)"
        },
        {
            "value": 37,
            "viewValue": "Bombeiro militar (coronel)"
        },
        {
            "value": 35,
            "viewValue": "Bombeiro militar (major)"
        },
        {
            "value": 31,
            "viewValue": "Bombeiro militar (sargento)"
        },
        {
            "value": 29,
            "viewValue": "Bombeiro militar (soldado)"
        },
        {
            "value": 32,
            "viewValue": "Bombeiro militar (subtenente)"
        },
        {
            "value": 33,
            "viewValue": "Bombeiro militar (tenente)"
        },
        {
            "value": 36,
            "viewValue": "Bombeiro militar (tenente-coronel)"
        },
        {
            "value": 38,
            "viewValue": "Cabeleireiro"
        },
        {
            "value": 39,
            "viewValue": "Camareiro"
        },
        {
            "value": 40,
            "viewValue": "Carteiro"
        },
        {
            "value": 125,
            "viewValue": "Caseiro"
        },
        {
            "value": 41,
            "viewValue": "Chaveiro"
        },
        {
            "value": 42,
            "viewValue": "Chefe de cozinha"
        },
        {
            "value": 43,
            "viewValue": "Comerciante"
        },
        {
            "value": 44,
            "viewValue": "Contador, técnico ou analista em contabilidade"
        },
        {
            "value": 45,
            "viewValue": "Coreógrafo"
        },
        {
            "value": 46,
            "viewValue": "Corretor de imóveis"
        },
        {
            "value": 47,
            "viewValue": "Corretor de seguros"
        },
        {
            "value": 48,
            "viewValue": "Costureira ou alfaiate"
        },
        {
            "value": 49,
            "viewValue": "Cozinheiro ou auxiliar de cozinha"
        },
        {
            "value": 50,
            "viewValue": "Dançarino ou bailarino"
        },
        {
            "value": 51,
            "viewValue": "Decorador"
        },
        {
            "value": 52,
            "viewValue": "Dentista"
        },
        {
            "value": 53,
            "viewValue": "Deputado"
        },
        {
            "value": 54,
            "viewValue": "Desenhista"
        },
        {
            "value": 55,
            "viewValue": "Digitador"
        },
        {
            "value": 56,
            "viewValue": "Economista"
        },
        {
            "value": 57,
            "viewValue": "Eletricista de instalações e manutenção"
        },
        {
            "value": 58,
            "viewValue": "Empregado doméstico"
        },
        {
            "value": 59,
            "viewValue": "Empresário / diretor geral de empresa"
        },
        {
            "value": 60,
            "viewValue": "Encanador"
        },
        {
            "value": 62,
            "viewValue": "Enfermeiro - exceto enfermeiro psiquiatrico"
        },
        {
            "value": 61,
            "viewValue": "Enfermeiro psiquiatrico"
        },
        {
            "value": 63,
            "viewValue": "Engenheiro civil e afins."
        },
        {
            "value": 64,
            "viewValue": "Engenheiro de minas"
        },
        {
            "value": 65,
            "viewValue": "Engenheiro de voo"
        },
        {
            "value": 66,
            "viewValue": "Engenheiro eletricista eletrônico e afins"
        },
        {
            "value": 67,
            "viewValue": "Engenheiro em computação"
        },
        {
            "value": 68,
            "viewValue": "Engenheiro mecânico e afins - exceto engenheiro mecânico nuclear"
        },
        {
            "value": 69,
            "viewValue": "Engenheiro mecânico nuclear"
        },
        {
            "value": 70,
            "viewValue": "Engenheiro mecatrônico"
        },
        {
            "value": 71,
            "viewValue": "Engenheiro químico"
        },
        {
            "value": 72,
            "viewValue": "Escritor"
        },
        {
            "value": 73,
            "viewValue": "Estagiário, bolsista ou trainee"
        },
        {
            "value": 74,
            "viewValue": "Estudante"
        },
        {
            "value": 75,
            "viewValue": "Farmacêutico"
        },
        {
            "value": 131,
            "viewValue": "Fisioterapeuta"
        },
        {
            "value": 132,
            "viewValue": "Fonoaudióloga"
        },
        {
            "value": 76,
            "viewValue": "Fotógrafo"
        },
        {
            "value": 77,
            "viewValue": "Frentista"
        },
        {
            "value": 127,
            "viewValue": "Funcionário público"
        },
        {
            "value": 78,
            "viewValue": "Garçom"
        },
        {
            "value": 79,
            "viewValue": "Gerente administrativo"
        },
        {
            "value": 80,
            "viewValue": "Geólogo"
        },
        {
            "value": 81,
            "viewValue": "Guarda-civil municipal"
        },
        {
            "value": 82,
            "viewValue": "Instalador de produtos ou acessórios"
        },
        {
            "value": 83,
            "viewValue": "Instrutor de autoescola"
        },
        {
            "value": 84,
            "viewValue": "Jardineiro"
        },
        {
            "value": 85,
            "viewValue": "Joalheiro"
        },
        {
            "value": 86,
            "viewValue": "Jornalista"
        },
        {
            "value": 87,
            "viewValue": "Juiz de direito"
        },
        {
            "value": 88,
            "viewValue": "Lavadeiro, em geral"
        },
        {
            "value": 89,
            "viewValue": "Manicure"
        },
        {
            "value": 90,
            "viewValue": "Maquiador"
        },
        {
            "value": 91,
            "viewValue": "Matemático"
        },
        {
            "value": 92,
            "viewValue": "Mecânico de veículos"
        },
        {
            "value": 99,
            "viewValue": "Militar em geral"
        },
        {
            "value": 135,
            "viewValue": "Ministro de culto religioso"
        },
        {
            "value": 93,
            "viewValue": "Modelo"
        },
        {
            "value": 94,
            "viewValue": "Motoboy"
        },
        {
            "value": 95,
            "viewValue": "Motorista de caminhão / transportador"
        },
        {
            "value": 96,
            "viewValue": "Motorista de carro, furgão ou veículo similar"
        },
        {
            "value": 97,
            "viewValue": "Motorista de ônibus urbanos, metropolitanos e rodoviários"
        },
        {
            "value": 98,
            "viewValue": "Médico"
        },
        {
            "value": 100,
            "viewValue": "Padeiro"
        },
        {
            "value": 101,
            "viewValue": "Paramédico"
        },
        {
            "value": 102,
            "viewValue": "Pedreiro"
        },
        {
            "value": 103,
            "viewValue": "Piloto de avião"
        },
        {
            "value": 128,
            "viewValue": "Pintor"
        },
        {
            "value": 104,
            "viewValue": "Policial civil - agente de segurança penitenciária"
        },
        {
            "value": 105,
            "viewValue": "Policial civil, exceto agente penitenciário"
        },
        {
            "value": 106,
            "viewValue": "Policial federal, ferroviário e rodoviário"
        },
        {
            "value": 107,
            "viewValue": "Policial militar"
        },
        {
            "value": 108,
            "viewValue": "Porteiro"
        },
        {
            "value": 109,
            "viewValue": "Produtor agrícola"
        },
        {
            "value": 110,
            "viewValue": "Professor"
        },
        {
            "value": 111,
            "viewValue": "Programador"
        },
        {
            "value": 112,
            "viewValue": "Psicólogo"
        },
        {
            "value": 113,
            "viewValue": "Publicitário"
        },
        {
            "value": 114,
            "viewValue": "Químico"
        },
        {
            "value": 115,
            "viewValue": "Repórter"
        },
        {
            "value": 116,
            "viewValue": "Tatuador"
        },
        {
            "value": 117,
            "viewValue": "Telefonista"
        },
        {
            "value": 133,
            "viewValue": "Terapeuta ocupacional"
        },
        {
            "value": 130,
            "viewValue": "Técnico em informática"
        },
        {
            "value": 118,
            "viewValue": "Vendedor / vendedor ambulante"
        },
        {
            "value": 119,
            "viewValue": "Vereador"
        },
        {
            "value": 120,
            "viewValue": "Veterinário"
        },
        {
            "value": 121,
            "viewValue": "Vigilante ou segurança"
        },
        {
            "value": 122,
            "viewValue": "Zelador"
        }
    ];
    static esportesRadicais = [
        {
            "value": 1,
            "viewValue": "Acquaride"
        },
        {
            "value": 2,
            "viewValue": "Acrobacia aérea"
        },
        {
            "value": 3,
            "viewValue": "Alpinismo"
        },
        {
            "value": 4,
            "viewValue": "Asa delta"
        },
        {
            "value": 5,
            "viewValue": "Automobilismo"
        },
        {
            "value": 6,
            "viewValue": "Balonismo"
        },
        {
            "value": 7,
            "viewValue": "Biathlon e triathlon"
        },
        {
            "value": 45,
            "viewValue": "Bodyboard"
        },
        {
            "value": 8,
            "viewValue": "Bungee jumping"
        },
        {
            "value": 11,
            "viewValue": "Canoagem / remo"
        },
        {
            "value": 12,
            "viewValue": "Canyoning / cascading"
        },
        {
            "value": 9,
            "viewValue": "Caça submarina"
        },
        {
            "value": 10,
            "viewValue": "Caçadores"
        },
        {
            "value": 13,
            "viewValue": "Ciclismo"
        },
        {
            "value": 14,
            "viewValue": "Corrida de aventura"
        },
        {
            "value": 15,
            "viewValue": "Escalada"
        },
        {
            "value": 16,
            "viewValue": "Escalada em rocha"
        },
        {
            "value": 17,
            "viewValue": "Espeleologia"
        },
        {
            "value": 18,
            "viewValue": "Hikking"
        },
        {
            "value": 19,
            "viewValue": "Iatismo / vela"
        },
        {
            "value": 20,
            "viewValue": "Jet-ski / ski"
        },
        {
            "value": 21,
            "viewValue": "Jóqueis"
        },
        {
            "value": 22,
            "viewValue": "Kitesurf"
        },
        {
            "value": 23,
            "viewValue": "Lutas marciais"
        },
        {
            "value": 24,
            "viewValue": "Mergulho"
        },
        {
            "value": 25,
            "viewValue": "Montain bike"
        },
        {
            "value": 26,
            "viewValue": "Montanhismo"
        },
        {
            "value": 27,
            "viewValue": "Motociclismo"
        },
        {
            "value": 28,
            "viewValue": "Motocross"
        },
        {
            "value": 29,
            "viewValue": "Mototrail"
        },
        {
            "value": 0,
            "viewValue": "Não contratado"
        },
        {
            "value": 30,
            "viewValue": "Off-road"
        },
        {
            "value": 48,
            "viewValue": "Outros"
        },
        {
            "value": 31,
            "viewValue": "Parapente / paragliding"
        },
        {
            "value": 33,
            "viewValue": "Piloto de prova (competição e marítimo)"
        },
        {
            "value": 32,
            "viewValue": "Pára-quedismo"
        },
        {
            "value": 34,
            "viewValue": "Rafting"
        },
        {
            "value": 35,
            "viewValue": "Rapel"
        },
        {
            "value": 36,
            "viewValue": "Sandboard"
        },
        {
            "value": 37,
            "viewValue": "Skate profissional"
        },
        {
            "value": 47,
            "viewValue": "Skysurf"
        },
        {
            "value": 38,
            "viewValue": "Snowboard"
        },
        {
            "value": 46,
            "viewValue": "Surf"
        },
        {
            "value": 39,
            "viewValue": "Trekking trophy"
        },
        {
            "value": 40,
            "viewValue": "Ultraleve"
        },
        {
            "value": 41,
            "viewValue": "Vôo livre"
        },
        {
            "value": 42,
            "viewValue": "Wakeboard"
        },
        {
            "value": 43,
            "viewValue": "Waveski"
        },
        {
            "value": 44,
            "viewValue": "Windsurf"
        }
    ];
    // FormsService.intervalNumberToViewValue();
    static valoresCoberturasObrigatorias = [
        {
            min: 30000,
            max: 300000,
            interval: 10000,
        },
        {
            min: 325000,
            max: 1000000,
            interval: 50000,
        },
        {
            min: 1100000,
            max: 2000000,
            interval: 100000,
        },
    ];
    // FormsService.intervalNumberToViewValue();
    static valoresCoberturasOpcionais = [
        {
            min: 0,
            max: 300000,
            interval: 10000,
        },
        {
            min: 325000,
            max: 1000000,
            interval: 50000,
        },
        {
            min: 1100000,
            max: 2000000,
            interval: 100000,
        },
    ];
    // FormsService.intervalNumberToViewValue();
    static valoresDiarios = [
        {
            min: 0,
            max: 100,
            interval: 25,
        },
        {
            min: 150,
            max: 400,
            interval: 50,
        },
        {
            min: 500,
            max: 1300,
            interval: 100,
        }
    ];
    static assistFuneral = [
        { value: 0, viewValue: 'Não' },
        { value: 1, viewValue: 'Funeral Individual' },
        { value: 2, viewValue: 'Funeral Familiar' },
    ];
    static assistFuneralValor = [
        { value: 0, viewValue: 'R$ 0,00' },
        { value: 2000, viewValue: 'R$ 2.000,00' },
        { value: 3000, viewValue: 'R$ 3.000,00' },
        { value: 4000, viewValue: 'R$ 4.000,00' },
        { value: 5000, viewValue: 'R$ 5.000,00' },
        { value: 6000, viewValue: 'R$ 6.000,00' },
        { value: 7000, viewValue: 'R$ 7.000,00' },
        { value: 8000, viewValue: 'R$ 8.000,00' },
        { value: 9000, viewValue: 'R$ 9.000,00' },
        { value: 10000, viewValue: 'R$ 10.000,00' },
        { value: 15000, viewValue: 'R$ 15.000,00' },
    ];
    static get executionType() {
        return 9;
    }
    static objSelects = {
        sexo: ConstantFormVida.sexo,
        estadoCivil: ConstantFormVida.estadoCivil,
        simOuNao: ConstantFormVida.simOuNao,
        valoresCoberturasObrigatorias: ConstantFormVida.valoresCoberturasObrigatorias,
        valoresCoberturasOpcionais: ConstantFormVida.valoresCoberturasOpcionais,
        assistFuneral: ConstantFormVida.assistFuneral,
        assistFuneralValor: ConstantFormVida.assistFuneralValor,
        valoresDIT: ConstantFormVida.valoresDiarios,
        valoresDIH: ConstantFormVida.valoresDiarios,
        esportesRadicais: ConstantFormVida.esportesRadicais,
        profissoes: undefined
    };
    // Arrays para percorrer campos do formulário
    static camposSegurado = [
        'nome',
        'dataNasc',
        'sexo',
        'estadoCivil',
        'fone',
        'email',
        'cep'
    ];
    static camposSeguradoDraft = {
        cpf: 'cpfCnpj',
        nome: 'nome',
        dataNasc: 'dataNasc',
        sexo: 'sexo',
        estadoCivil: 'estadoCivil',
        cep: 'cep',
        uf: 'uf',
        cidade: 'cidade',
        bairro: 'bairro',
        logradouro: 'logradouro',
        fone: 'fone1',
        email: 'email',
    };
    static camposPerfilDraft = {
        altura: 'altura',
        peso: 'peso',
        rendaMensal: 'rendaMensal',
    };
    static camposRemoverDraftSegurado = [
        "profissao",
        "profissaoTxt"
    ];
    static camposCoberturasDraft = {
        assistMorte: 'isAppMorte',
        isAppMorteAcidental: 'isAppMorteAcidental',
        isAppInvalidez: 'isAppInvalidez',
        assistFuneral: 'funeral',
        isDespesasMedicasHospitalares: 'isDespesasMedicasHospitalares',
        isInvalidezDoenca: 'isInvalidezDoenca',
        valorDIT: 'DIT',
        valorDoencasGraves: 'isDoencasGravesGrupo'
    };
    static camposCoberturasPreencherDraft = {
        assistMorte: 'isAppMorte',
        isAppMorteAcidental: 'isAppMorteAcidental',
        isAppInvalidez: 'isAppInvalidez',
        isDespesasMedicasHospitalares: 'isDespesasMedicasHospitalares',
        isInvalidezDoenca: 'isInvalidezDoenca'
    };
    // ICONES
    static icons = [
        'briefcase-edit',
        'alert-circle-outline',
        'check-circle-outline',
        'delete',
        'magnify',
        'window-close'
    ];
    // MASCARAS
    static get maskValidate() {
        return {
            ALTURA: '0.00',
            CEP: '00000-000',
            CPF: '000.000.000-00',
            DATA: '00/00/0000',
            FONE: '(00) 0000-00009',
            FONE_2: '(00) 00000-0000',
            MAIL: 'A+@\.A+',
            PESO: '009'
        };
    }
    // PATTERNS
    static get patternValidade() {
        return {
            CPF: '[0-9]{3}.[0-9]{3}.[0-9]{3}-[0-9]{2}',
            INDEFINIDO: '[0-9]{3}.[0-9]{3}.[0-9]{3}-[0-9]{2}|\\d{2}.\\d{3}.\\d{3}\\/\\d{4}\\-\\d{2}',
            NOME: '[A-Za-z0-9áàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ.\-\/&_-]+\\s+[A-Za-z0-9áàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ.\-\/&\\s]{3,}',
            DATA: '[0-9]{1,2}/[0-9]{1,2}/[0-9]{4}',
            CEP: '[0-9]{5}-[0-9]{3}',
            FONE: '\\([0-9]{2}\\)\\s[0-9]{4,5}-[0-9]{4,6}',
            UF: '[A-Z]{2}',
            NUMERO: '[0-9]{1,6}'
        };
    }
    //CONTROLERS
    static get controlerBusca() {
        return {
            segurado: {
                buscando: false,
                status: undefined,
                ultimaBusca: undefined
            },
            endereco: {
                buscando: false,
                status: undefined,
                ultimaBusca: undefined,
                cidade: ''
            },
            profissoes: {
                buscando: false,
                status: undefined,
                ultimaBusca: undefined,
                mensagens: {
                    inativa: "Seguradora inativa.",
                    naoEncontrada: "Pesquisa não encontrou nenhuma profissão, tente outra descrição."
                }
            },
        };
    }
    static informacoesDefault = {
        coberturas: {
            assistMorte: 50000,
            isAppMorteAcidental: 0,
            isAppInvalidez: 0,
            assistFuneral: 0,
            isDespesasMedicasHospitalares: 0,
            isInvalidezDoenca: 0,
            valorDIT: 0,
            valorDoencasGraves: 0,
        },
        perfil: {
            praticaEsporteRadical: { value: 0, viewValue: "Não contratado" },
        },
        vigencia: {
            vigenciaIni: '' //FormsService.geraDataVigencia()
        }
    };
    static botoesSubmit = [
        'submitFormSegurado',
        'submitFormPerfil',
        'submitFormCoberturas',
        'submitFormVigencia'
    ];
    static valoresEstaticosDraft = {
        ramo: 91
    };
}

class FormsService {
    _snackBar;
    alertConfirmService;
    formularioValidoEmiter = new EventEmitter();
    preencheDraftEmiter = new EventEmitter();
    preencheFormularioEmiter = new EventEmitter();
    resetaFormularioEmiter = new EventEmitter();
    atualizaDraftFinal = new EventEmitter();
    setarInfosDefaultEmiter = new EventEmitter();
    userInfosEmiter = new EventEmitter();
    clienteIndisponivelEmiter = new EventEmitter();
    seguradorasStatusEmiter = new EventEmitter();
    currentVersionEmiter = new EventEmitter();
    constructor(_snackBar, alertConfirmService) {
        this._snackBar = _snackBar;
        this.alertConfirmService = alertConfirmService;
    }
    atualizaCampos(objetoInfos, formulario) {
        Object.keys(objetoInfos).forEach(campo => {
            formulario.controls[campo] && formulario.controls[campo].setValue(FormsService.formatField(campo, objetoInfos[campo]));
        });
    }
    clienteIndisponivel(clienteIndisponivel) {
        this.clienteIndisponivelEmiter.emit(clienteIndisponivel);
    }
    converteDataAmerica(data) {
        let novadata;
        if (data !== "" && data !== undefined && data !== null) {
            try {
                const regex = /(\d\/)/gm;
                if (regex.exec(data) !== null) {
                    let split = data.split('/');
                    novadata = split[2] + "-" + split[1] + "-" + split[0] + "T17:47:20.353Z";
                }
                else {
                    let dataString = /(\d{4}-\d{2}-\d{2}$)/gm;
                    if (dataString.exec(data) !== null)
                        data = data + "T17:47:20.353Z";
                    let now = new Date(data);
                    let mes = now.getMonth() + 1;
                    if ((now.getMonth() + 1) < 10)
                        mes = "0" + mes;
                    let dia = now.getDate();
                    if (now.getDate() < 10)
                        dia = "0" + dia;
                    novadata = dia + "/" + mes + "/" + now.getFullYear();
                }
                return novadata;
            }
            catch (error) {
                return "";
            }
        }
        else {
            return "";
        }
    }
    static converteDataAmerica(data) {
        let novadata;
        if (data !== "" && data !== undefined && data !== null) {
            try {
                const regex = /(\d\/)/gm;
                if (regex.exec(data) !== null) {
                    let split = data.split('/');
                    novadata = split[2] + "-" + split[1] + "-" + split[0] + "T17:47:20.353Z";
                }
                else {
                    let dataString = /(\d{4}-\d{2}-\d{2}$)/gm;
                    if (dataString.exec(data) !== null)
                        data = data + "T17:47:20.353Z";
                    let now = new Date(data);
                    let mes = now.getMonth() + 1;
                    if ((now.getMonth() + 1) < 10)
                        mes = "0" + mes;
                    let dia = now.getDate();
                    if (now.getDate() < 10)
                        dia = "0" + dia;
                    novadata = dia + "/" + mes + "/" + now.getFullYear();
                }
                return novadata;
            }
            catch (error) {
                return "";
            }
        }
        else {
            return "";
        }
    }
    async createConfirm(title, question, btnOk, btnCancel) {
        return await this.alertConfirmService.confirm(title, question, btnOk, btnCancel);
    }
    async createAlert(title, message) {
        return await this.alertConfirmService.alert(title, message);
    }
    static dataValidaNascimento(data) {
        if (data) {
            var anoVigente = new Date(Date.now()).getFullYear();
            var data = data.split('/');
            var dia = parseInt(data[0]);
            var mes = parseInt(data[1]);
            var ano = parseInt(data[2]);
            var meses = {
                "1": { descricao: "Janeiro", dias: 31 },
                "2": { descricao: "Fevereiro", dias: this.isBissexto(ano) },
                "3": { descricao: "Março", dias: 31 },
                "4": { descricao: "Abril", dias: 30 },
                "5": { descricao: "Maio", dias: 31 },
                "6": { descricao: "Junho", dias: 30 },
                "7": { descricao: "Julho", dias: 31 },
                "8": { descricao: "Agosto", dias: 31 },
                "9": { descricao: "Setembro", dias: 30 },
                "10": { descricao: "Outubro", dias: 31 },
                "11": { descricao: "Novembro", dias: 30 },
                "12": { descricao: "Dezembro", dias: 31 }
            };
            if (mes > 0 && mes <= 12) {
                if (ano > (anoVigente - 100) && (ano <= anoVigente - 18)) {
                    if (dia > 0 && dia <= meses[mes].dias) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
                else {
                    return false;
                }
            }
        }
    }
    static dataValida(data) {
        if (data) {
            var anoVigente = new Date(Date.now()).getFullYear();
            var data = data.split('/');
            var dia = parseInt(data[0]);
            var mes = parseInt(data[1]);
            var ano = parseInt(data[2]);
            var meses = {
                "1": { descricao: "Janeiro", dias: 31 },
                "2": { descricao: "Fevereiro", dias: this.isBissexto(ano) },
                "3": { descricao: "Março", dias: 31 },
                "4": { descricao: "Abril", dias: 30 },
                "5": { descricao: "Maio", dias: 31 },
                "6": { descricao: "Junho", dias: 30 },
                "7": { descricao: "Julho", dias: 31 },
                "8": { descricao: "Agosto", dias: 31 },
                "9": { descricao: "Setembro", dias: 30 },
                "10": { descricao: "Outubro", dias: 31 },
                "11": { descricao: "Novembro", dias: 30 },
                "12": { descricao: "Dezembro", dias: 31 }
            };
            if (mes > 0 && mes <= 12) {
                if (ano > (anoVigente - 100)) {
                    if (dia > 0 && dia <= meses[mes].dias) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
                else {
                    return false;
                }
            }
        }
    }
    desabilitaCampos(arrayNomeCampos, formulario) {
        arrayNomeCampos.forEach(campo => formulario.controls[campo].disable());
    }
    enviaUserInfos(userInfos, vazio) {
        this.userInfosEmiter.emit([userInfos, vazio]);
    }
    enviaSeguradorasStatus(seguradorasStatus) {
        this.seguradorasStatusEmiter.emit(seguradorasStatus);
    }
    enviarCurrentVersion(currentVersion) {
        this.currentVersionEmiter.emit(currentVersion);
    }
    enviaValidadeFormulario(infos) {
        this.formularioValidoEmiter.emit(infos);
    }
    static formBuilderCpf() {
        return (control) => {
            let cpfValid = this.validaCpf(control.value);
            return !cpfValid ? { validaCpf: { value: control.value } } : null;
        };
    }
    static formBuilderValidaFone() {
        return (control) => {
            let foneValid = this.validaFone(this.limparString(control.value));
            return !foneValid ? { foneValid: { value: control.value } } : null;
        };
    }
    static formatAltura(value) {
        try {
            if (value !== null) {
                const altura = value.toString();
                return altura.replace(/^(\d{1})(\d{1,2})$/g, '$1.$2');
            }
            else {
                return '';
            }
        }
        catch (error) {
            return '';
        }
    }
    static formatAssistFuneral(value) {
        return value?.tipo ? value.tipo : 0;
    }
    static formatCep(value) {
        try {
            const cep = value.toString();
            return cep.replace(/(\d{5})(\d{3})/g, "\$1-\$2");
        }
        catch (error) {
            return "";
        }
    }
    formatCnpjCpf(value) {
        try {
            const cnpjCpf = value.replace(/\D/g, '');
            if (cnpjCpf.length === 11) {
                return cnpjCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3-\$4");
            }
            return cnpjCpf.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "\$1.\$2.\$3/\$4-\$5");
        }
        catch (error) {
            return "";
        }
    }
    static formatCnpjCpf(value) {
        try {
            const cnpjCpf = value.replace(/\D/g, '');
            if (cnpjCpf.length === 11) {
                return cnpjCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3-\$4");
            }
        }
        catch (error) {
            return "";
        }
    }
    static formatField(nomeCampo, value) {
        switch (nomeCampo) {
            case 'cpf':
                return FormsService.formatCnpjCpf(value);
            case 'dataNasc':
            case 'vigenciaIni':
                return value == '0000-00-00' ? null : FormsService.converteDataAmerica(value);
            case 'fone':
                return FormsService.formatFone(value);
            case 'cep':
                return FormsService.formatCep(value);
            case 'profissao':
                return "";
            case 'altura':
                return FormsService.formatAltura(value);
            case 'assistFuneral':
                return FormsService.formatAssistFuneral(value);
            case 'praticaEsporteRadical':
                return FormsService.formatPraticaEsporteRadical(value);
            case 'valorDoencasGraves':
            case 'valorDIT':
                return FormsService.formatValor(value);
            case 'isAppMorteAcidental':
            case 'isAppInvalidez':
            case 'isDespesasMedicasHospitalares':
            case 'isInvalidezDoenca':
                return FormsService.formatCobertura(value);
            default:
                return value;
        }
    }
    static formatFone(value) {
        try {
            const fone = value.toString();
            return fone.replace(/(\d{2})(\d{4,5})(\d{4})/g, "(\$1) \$2-\$3");
        }
        catch (error) {
            return "";
        }
    }
    static formatPraticaEsporteRadical(value) {
        try {
            if (!value)
                value = 0;
            let esporte = ConstantFormVida.esportesRadicais.find(esporte => esporte.value === value);
            return esporte ? esporte : "";
        }
        catch (error) {
            return "";
        }
    }
    static formatProfissao(value) {
        try {
            let profissao = ConstantFormVida.profissoes.find(profissao => profissao.value === value);
            return profissao ? profissao : "";
        }
        catch (error) {
            return "";
        }
    }
    static formatValor(value) {
        return value?.valor ? value.valor : 0;
    }
    static formatCobertura(value) {
        return value ? value : 0;
    }
    static formatFieldToDraft(nomeCampo, value) {
        switch (nomeCampo) {
            case 'dataNasc':
            case 'vigenciaIni':
                return FormsService.converteDataAmerica(value);
            case 'fone':
            case 'cep':
            case 'cpf':
                return this.limparString(value);
            case 'numero':
            case 'peso':
                return value ? parseInt(value) : null;
            case 'altura':
                return value ? parseFloat(value) * 100 : null;
            case 'profissao':
            case 'praticaEsporteRadical':
                return value ? value?.value : null;
            default:
                return value;
        }
    }
    salvaDraftFinal() {
        this.atualizaDraftFinal.emit({});
    }
    static geraDataVigencia(dataVigencia) {
        let data;
        if (dataVigencia)
            data = new Date(this.converteDataAmerica(dataVigencia));
        else {
            data = new Date();
            data = data.setDate(data.getDate() + 1);
        }
        return this.converteDataAmerica(data);
    }
    habilitaCampos(arrayNomeCampos, formulario) {
        arrayNomeCampos.forEach(campo => formulario.controls[campo].enable());
    }
    static isBissexto(ano) {
        if (ano) {
            try {
                if ((ano % 4 == 0) && ((ano % 100 != 0) || (ano % 400 == 0))) {
                    return 29;
                }
                else {
                    return 28;
                }
            }
            catch (error) {
                return false;
            }
        }
    }
    isVendaCruzada(draft) {
        return draft && !draft.hasOwnProperty('configuracoes');
    }
    intervalNumberToViewValue(val) {
        let generateInterval = function (obj) {
            let valAtual = obj.min;
            let limite = obj.max;
            let interval = obj.interval;
            let arr = [];
            while (valAtual <= limite) {
                arr.push({ value: valAtual, viewValue: valAtual.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) });
                valAtual = valAtual + interval;
            }
            return arr;
        };
        if (Array.isArray(val)) {
            let arr = [];
            val.map(function (v) {
                arr = [...arr, ...generateInterval(v)];
            });
            return arr;
        }
        else {
            return generateInterval(val);
        }
    }
    static limparString(srt) {
        try {
            return srt.replace(/[\.\-\/(\/)\s)]/g, '');
        }
        catch (error) {
            false;
        }
    }
    limparString(srt) {
        try {
            return srt.replace(/[\.\-\/(\/)\s)]/g, '');
        }
        catch (error) {
            false;
        }
    }
    openSnackbarModal(message) {
        const snackbarConfigs = {
            message,
            action: 'Fechar',
            cssClasses: ['snackbar', 'red-snackbar'],
            duration: 4000,
            horizontalPosition: 'center'
        };
        const config = new MatSnackBarConfig();
        config.panelClass = snackbarConfigs.cssClasses;
        config.duration = snackbarConfigs.duration;
        this._snackBar.open(snackbarConfigs.message, snackbarConfigs.action, config);
    }
    preencheDraft(draft) {
        this.setaPropriedadesFixas(draft);
        this.removePropriedades(draft);
        this.preencheDraftEmiter.emit(draft);
    }
    preencheFormulario(draft) {
        this.preencheFormularioEmiter.emit(draft);
    }
    resetaFormulario() {
        this.resetaFormularioEmiter.emit();
    }
    setaInfosDefault(formulario, nomeFormulario) {
        Object.keys(ConstantFormVida.informacoesDefault[nomeFormulario]).forEach(campo => {
            formulario.controls[campo] && formulario.controls[campo].setValue(ConstantFormVida.informacoesDefault[nomeFormulario][campo]);
        });
    }
    setarInfosDefault() {
        this.setarInfosDefaultEmiter.emit();
    }
    setaPropriedadesFixas(draft) {
        try {
            if (draft) {
                Object.keys(ConstantFormVida.valoresEstaticosDraft).forEach(campo => {
                    !draft?.[campo] ? draft[campo] = ConstantFormVida.valoresEstaticosDraft[campo] : null;
                });
            }
            if (this.isVendaCruzada(draft)) {
                draft.configuracoes = {};
                draft.configuracoes.funeral = {};
            }
        }
        catch (error) {
            return false;
        }
    }
    removePropriedades(draft) {
        if (draft && draft.hasOwnProperty('segurado')) {
            ConstantFormVida.camposRemoverDraftSegurado.forEach(campo => {
                delete draft.segurado[campo];
            });
        }
    }
    static validaCpf(val) {
        try {
            if (val.length == 14) {
                var cpf = val.trim();
                cpf = cpf.replace(/\./g, '');
                cpf = cpf.replace('-', '');
                cpf = cpf.split('');
                var v1 = 0;
                var v2 = 0;
                var aux = false;
                for (var i = 1; cpf.length > i; i++) {
                    if (cpf[i - 1] != cpf[i]) {
                        aux = true;
                    }
                }
                if (aux == false) {
                    return false;
                }
                for (var i = 0, p = 10; (cpf.length - 2) > i; i++, p--) {
                    v1 += cpf[i] * p;
                }
                v1 = ((v1 * 10) % 11);
                if (v1 == 10) {
                    v1 = 0;
                }
                if (v1 != cpf[9]) {
                    return false;
                }
                for (var i = 0, p = 11; (cpf.length - 1) > i; i++, p--) {
                    v2 += cpf[i] * p;
                }
                v2 = ((v2 * 10) % 11);
                if (v2 == 10) {
                    v2 = 0;
                }
                if (v2 != cpf[10]) {
                    return false;
                }
                else {
                    return true;
                }
            }
        }
        catch (error) {
            return false;
        }
    }
    static validarData() {
        return (control) => {
            let dataValid = this.dataValida(control.value);
            return !dataValid ? { validaData: { value: control.value } } : null;
        };
    }
    static validarDataNascimento() {
        return (control) => {
            let dataValid = this.dataValidaNascimento(control.value);
            return !dataValid ? { validaData: { value: control.value } } : null;
        };
    }
    static validaFone(val) {
        try {
            let nove = val.substr(2, 1);
            if (val.length === 11 && nove === '9') {
                return true;
            }
            else if (val.length === 10) {
                return true;
            }
            else if (val.length === 0) {
                return true;
            }
            else {
                return false;
            }
        }
        catch (error) {
            return false;
        }
    }
    static validateProperty(property, validators) {
        return (control) => {
            const propertyVal = control.value && control.value[property];
            const newFc = new FormControl(propertyVal);
            const failedValidators = validators.map(v => v(newFc)).filter(v => !!v);
            return failedValidators.length ? { invalidProperty: failedValidators } : null;
        };
    }
    verificaDataFormulario(data) {
        let today = new Date();
        today.setHours(8, 0, 0, 0);
        const regex = /(\d\/)/gm; //data com barras
        if (regex.exec(data) !== null) {
            let split = data.split('/');
            let novadata = split[2] + "-" + split[1] + "-" + split[0] + "T11:00:00.0Z";
            let vigenciaIni = new Date(novadata);
            return vigenciaIni < today ? false : true;
        }
        else {
            return false;
        }
    }
    getPathLogoById(idSeg) {
        return 'assets/images/logos-seguradoras/seguradora' + idSeg + '.png';
    }
    removeOpcoesRepetidas(arrayOpcoes) {
        return Array.from(new Map(arrayOpcoes.map(item => [item.Key, item])).values());
    }
    static validaValorDoencasGraves(c) {
        return function (c2) {
            const value1 = c.value;
            const value2 = c2.value;
            if (value2 > value1) {
                return {
                    doencasMaiorQueMorte: {
                        valid: false,
                        message: 'Valor limitado a cobertura de morte.'
                    }
                };
            }
            return null;
        };
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormsService, deps: [{ token: i1.MatSnackBar }, { token: 'alert-confirm-service' }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormsService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1.MatSnackBar }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['alert-confirm-service']
                }] }] });

class IconsService {
    matIconRegistry;
    domSanitizer;
    constructor(matIconRegistry, domSanitizer) {
        this.matIconRegistry = matIconRegistry;
        this.domSanitizer = domSanitizer;
    }
    registerIcons(icons) {
        this.loadIcons(icons, 'assets/icons');
    }
    loadIcons(iconKeys, iconUrl) {
        iconKeys.forEach(key => {
            this.matIconRegistry.addSvgIcon(key, this.domSanitizer.bypassSecurityTrustResourceUrl(`${iconUrl}/${key}.svg`));
        });
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: IconsService, deps: [{ token: i1$1.MatIconRegistry }, { token: i2.DomSanitizer }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: IconsService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: IconsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1$1.MatIconRegistry }, { type: i2.DomSanitizer }] });

class FormularioVidaSeguradoComponent {
    api;
    formBuilder;
    formsService;
    buscaControler = ConstantFormVida.controlerBusca;
    masks = ConstantFormVida.maskValidate;
    maskTelefone = this.masks.FONE;
    patterns = ConstantFormVida.patternValidade;
    selects = ConstantFormVida.objSelects;
    subscriptions = new Subscription();
    formVidaSegurado;
    informacoesUsuario;
    habilitar = {};
    recalculo = false;
    clienteDisponivel = true;
    set segurados(value) {
        if (value && typeof (value) === 'object' && Object.keys(value).length) {
            this.habilitar = value;
            this.recalculo = true;
        }
    }
    constructor(api, formBuilder, formsService) {
        this.api = api;
        this.formBuilder = formBuilder;
        this.formsService = formsService;
        this.formVidaSegurado = this.formBuilder.group({
            cpf: new FormControl('', [Validators.required, Validators.pattern(this.patterns.CPF), FormsService.formBuilderCpf()]),
            nome: new FormControl('', [Validators.required, Validators.minLength(4), Validators.pattern(this.patterns.NOME)]),
            dataNasc: new FormControl('', [Validators.required, Validators.pattern(this.patterns.DATA), FormsService.validarDataNascimento()]),
            sexo: new FormControl('', [Validators.required]),
            estadoCivil: new FormControl('', [Validators.required]),
            fone: new FormControl('', [Validators.pattern(this.patterns.FONE), FormsService.formBuilderValidaFone()]),
            email: new FormControl('', [Validators.email, Validators.maxLength(60)]),
            cep: new FormControl('', [Validators.required, Validators.pattern(this.patterns.CEP)]),
            uf: new FormControl('', []),
            cidade: new FormControl('', []),
            bairro: new FormControl('', []),
            logradouro: new FormControl('', []),
        });
    }
    ngOnInit() {
        this.inscreverEmiters();
    }
    ngOnDestroy() {
        this.formsService.salvaDraftFinal();
        this.subscriptions.unsubscribe();
    }
    alteraMascaraTelefone(telefone) {
        try {
            this.formVidaSegurado.controls.fone.clearValidators();
            this.maskTelefone = telefone && telefone.length > 14 ? this.masks.FONE_2 : this.masks.FONE;
            telefone && telefone.length > 14
                ? this.formVidaSegurado.controls.fone.setValidators([FormsService.formBuilderValidaFone()])
                : this.formVidaSegurado.controls.fone.setValidators([FormsService.formBuilderValidaFone()]);
        }
        catch (error) {
            return false;
        }
    }
    async buscaInfosEndereco() {
        let cepValido = this.formVidaSegurado.controls.cep.valid;
        let buscaAnteriorDiferenteAtual = this.buscaControler.endereco.ultimaBusca != this.formsService.limparString(this.formVidaSegurado.controls.cep.value);
        if (cepValido && buscaAnteriorDiferenteAtual) {
            this.buscaControler.endereco.buscando = true;
            let infosEndereco = await this.api.getEndereco(this.formsService.limparString(this.formVidaSegurado.controls.cep.value));
            if (infosEndereco && infosEndereco.length > 0 && infosEndereco[0]) {
                this.formsService.atualizaCampos(infosEndereco[0], this.formVidaSegurado);
                this.buscaControler.endereco.status = 'ENCONTROU';
                this.buscaControler.endereco.cidade = this.formVidaSegurado.controls.cidade.value ? this.formVidaSegurado.controls.cidade.value : '';
            }
            else
                this.buscaControler.endereco.status = 'NAO-ENCONTROU';
            this.buscaControler.endereco.ultimaBusca = this.formsService.limparString(this.formVidaSegurado.controls.cep.value);
            this.buscaControler.endereco.buscando = false;
        }
    }
    async buscaInfosSegurado() {
        let cpfValido = this.formVidaSegurado.controls.cpf.valid;
        let cpf = this.formsService.limparString(this.formVidaSegurado.controls.cpf.value);
        let buscaAnteriorDiferenteAtual = this.buscaControler.segurado.ultimaBusca != cpf;
        if (cpfValido && buscaAnteriorDiferenteAtual) {
            this.buscaControler.segurado.buscando = true;
            this.formsService.desabilitaCampos(ConstantFormVida.camposSegurado, this.formVidaSegurado);
            let infosSegurado = await this.api.getSegurado(cpf).catch(error => { return error; });
            if (infosSegurado && infosSegurado.length > 0 && infosSegurado[0]) {
                if (infosSegurado[0].hasOwnProperty('profissao'))
                    delete infosSegurado[0].profissao;
                let cepBuscadoDiferente = FormsService.formatCep(infosSegurado[0].cep) !== this.formVidaSegurado.controls.cep.value;
                let substituirEndereco = true;
                if (this.formVidaSegurado.controls.cep.value && infosSegurado[0].cep && cepBuscadoDiferente && this.buscaControler.endereco.status == 'ENCONTROU') {
                    if (this.recalculo)
                        substituirEndereco = false;
                    else
                        substituirEndereco = await this.formsService.createConfirm("Alteração de Endereço", `O CEP atual da cotação é ${this.formVidaSegurado.controls.cep.value}, mas o CEP buscado foi ${FormsService.formatCep(infosSegurado[0].cep)}. Deseja atualizá-lo?`, "Atualizar", "Manter");
                }
                if (!substituirEndereco) {
                    const camposEndereco = ['cep', 'uf', 'cidade', 'bairro', 'logradouro'];
                    camposEndereco.forEach(nomeCampo => delete infosSegurado[0][nomeCampo]);
                }
                this.formsService.atualizaCampos(infosSegurado[0], this.formVidaSegurado);
                this.getStatusCEP();
            }
            this.formsService.habilitaCampos(ConstantFormVida.camposSegurado, this.formVidaSegurado);
            this.buscaControler.segurado.ultimaBusca = cpf;
            this.buscaControler.segurado.buscando = false;
        }
    }
    carregaInfosDraft(draft) {
        if (draft && Object.keys(this.formVidaSegurado.controls).length) {
            Object.keys(ConstantFormVida.camposSeguradoDraft).forEach(campo => {
                this.formVidaSegurado.controls[campo] &&
                    this.formVidaSegurado.controls[campo].setValue(FormsService.formatField(campo, draft?.segurado?.[ConstantFormVida.camposSeguradoDraft[campo]]));
            });
        }
    }
    executaFuncoesIniciais() {
        this.getStatusCEP();
        this.setaCPFCarregado();
    }
    async getStatusCEP() {
        if (this.formVidaSegurado.controls.cep.value) {
            let infosEndereco = await this.api.getEndereco(this.formsService.limparString(this.formVidaSegurado.controls.cep.value));
            if (infosEndereco && infosEndereco.length > 0 && infosEndereco[0]) {
                this.buscaControler.endereco.status = 'ENCONTROU';
                this.buscaControler.endereco.cidade = infosEndereco[0]?.cidade ? infosEndereco[0].cidade : '';
            }
            else
                this.buscaControler.endereco.status = 'NAO-ENCONTROU';
        }
    }
    inscreverEmiters() {
        this.subscriptions.add(this.formsService.resetaFormularioEmiter.subscribe(() => {
            this.formVidaSegurado.reset();
        }));
        this.subscriptions.add(this.formVidaSegurado?.valueChanges.subscribe(() => {
            this.formsService.enviaValidadeFormulario({ formularioNome: 'segurado', valido: this.formVidaSegurado.valid });
        }));
        this.subscriptions.add(this.formsService.userInfosEmiter.subscribe(arrayInfos => {
            this.informacoesUsuario = arrayInfos[0];
            let vazio = arrayInfos[1];
            this.verificaClienteDisponivel(this.formsService.limparString(this.formVidaSegurado.controls.cpf.value), false);
            if (this.informacoesUsuario && this.informacoesUsuario?.dadosCorretoraPadrao && vazio)
                this.usarDadosCorretoraPadrao();
        }));
        this.subscriptions.add(this.formsService.preencheFormularioEmiter.subscribe(draft => {
            this.carregaInfosDraft(draft);
            this.executaFuncoesIniciais();
        }));
        this.subscriptions.add(this.formsService.preencheDraftEmiter.subscribe(draft => {
            this.preencheDraft(draft);
        }));
    }
    preencheDraft(draft) {
        try {
            if (draft && Object.keys(this.formVidaSegurado?.controls).length) {
                Object.keys(ConstantFormVida.camposSeguradoDraft).forEach(campo => {
                    draft.segurado[ConstantFormVida.camposSeguradoDraft[campo]] = FormsService.formatFieldToDraft(campo, this.formVidaSegurado.controls[campo].value);
                });
                draft.segurado.fone = FormsService.formatFieldToDraft('fone', this.formVidaSegurado.controls.fone.value);
            }
        }
        catch (error) {
            return false;
        }
    }
    setaCPFCarregado() {
        if (this.formVidaSegurado.controls.cpf.value) {
            this.buscaControler.segurado.ultimaBusca = this.formsService.limparString(this.formVidaSegurado.controls.cpf.value);
            this.buscaControler.segurado.buscando = false;
        }
    }
    usarDadosCorretoraPadrao() {
        this.usarEmailCorretora();
        this.usarFoneCorretora();
    }
    usarEmailCorretora() {
        this.formVidaSegurado.controls.email.setValue(this.informacoesUsuario?.emailCorretoraPadrao);
    }
    usarFoneCorretora() {
        this.formVidaSegurado.controls.fone.setValue(FormsService.formatFone(this.informacoesUsuario?.foneCorretoraPadrao));
    }
    async verificaClienteDisponivel(cpf, manual) {
        if (this.api?.verificarClienteDisponivel && this.informacoesUsuario && cpf) {
            try {
                let ret = await this.api.clienteDisponivel(cpf);
                this.clienteDisponivel = ret?.cpf_cnpj_autorizado;
                this.formsService.clienteIndisponivel(!this.clienteDisponivel);
                if (!this.clienteDisponivel && manual) {
                    await this.formsService.createAlert("Atenção", "Este cálculo pertence a outro corretor, não será possível prosseguir com a cotação.");
                    return false;
                }
            }
            catch (error) {
                this.clienteDisponivel = true;
                this.formsService.clienteIndisponivel(!this.clienteDisponivel);
                return false;
            }
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormularioVidaSeguradoComponent, deps: [{ token: 'api' }, { token: i1$2.FormBuilder }, { token: FormsService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: FormularioVidaSeguradoComponent, selector: "formulario-vida-segurado", inputs: { segurados: "segurados" }, ngImport: i0, template: "<form class=\"col-12 form-step\"  [formGroup]=\"formVidaSegurado\">\r\n    <mat-form-field [hidden]=\"!habilitar?.SEGURADO_CPFCNPJ && recalculo\" [ngClass]=\"!habilitar?.SEGURADO_CPFCNPJ ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>CPF</mat-label>\r\n        <input matInput name=\"cpf\" formControlName=\"cpf\" placeholder=\"Ex. 000.000.000-00\" autocomplete=\"off\" [mask]=\"masks.CPF\" [dropSpecialCharacters]=\"false\" (blur)=\"buscaInfosSegurado()\"/>\r\n        <mat-spinner class=\"spinnerLoading\" [@fadeInOut] *ngIf=\"buscaControler.segurado.buscando\" mat-spinner diameter=\"20\"></mat-spinner>\r\n        <mat-error *ngIf=\"formVidaSegurado.get('cpf').hasError('validaCpf')\">N\u00FAmero do documento inv\u00E1lido.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"!habilitar?.SEGURADO_NOME && recalculo\" [ngClass]=\"!habilitar?.SEGURADO_NOME ? 'col-12 col-md-6 col-lg-6 col-xl-9' : 'col-12'\">\r\n        <mat-label>Nome completo</mat-label>\r\n        <input matInput name=\"nome\" formControlName=\"nome\" class=\"text-capitalize\" autocomplete=\"off\"/>\r\n        <mat-error *ngIf=\"formVidaSegurado.get('nome').hasError('pattern')\">Por favor, insira nome e sobrenome</mat-error>\r\n        <mat-error *ngIf=\"formVidaSegurado.get('nome').hasError('required')\">Por favor, insira nome e sobrenome</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"!habilitar?.SEGURADO_DATANASC && recalculo\" [ngClass]=\"!habilitar?.SEGURADO_DATANASC ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>Data de Nascimento</mat-label>\r\n        <input matInput name=\"dataNasc\" formControlName=\"dataNasc\" [mask]=\"masks.DATA\" [dropSpecialCharacters]=\"false\" autocomplete=\"off\"/>\r\n        <mat-error *ngIf=\"formVidaSegurado.get('dataNasc').hasError('validaData')\">Data Inv\u00E1lida.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"!habilitar?.SEGURADO_SEXO && recalculo\" [ngClass]=\"!habilitar?.SEGURADO_SEXO ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>Sexo</mat-label>\r\n        <mat-select name=\"sexo\" formControlName=\"sexo\">\r\n            <mat-option *ngFor=\"let s of selects.sexo\" [value]=\"s.value\" [attr.custom-reflect-value]=\"s.value\">\r\n                {{ s.viewValue }}\r\n            </mat-option>\r\n        </mat-select>\r\n        <mat-error *ngIf=\"formVidaSegurado.get('sexo').hasError('required')\">Por favor, selecione um sexo.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"!habilitar?.SEGURADO_ESTADOCIVIL && recalculo\" [ngClass]=\"!habilitar?.SEGURADO_ESTADOCIVIL ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>Estado civil</mat-label>\r\n        <mat-select name=\"estadoCivil\" formControlName=\"estadoCivil\">\r\n            <mat-option *ngFor=\"let e of selects.estadoCivil\" [value]=\"e.value\" [attr.custom-reflect-value]=\"e.value\">\r\n                {{ e.viewValue }}\r\n            </mat-option>\r\n        </mat-select>\r\n        <mat-error *ngIf=\"formVidaSegurado.get('estadoCivil').hasError('required')\">Por favor, selecione um estado civil.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"!habilitar?.SEGURADO_CEP && recalculo\"  [ngClass]=\"!habilitar?.SEGURADO_CEP ? 'col-12 col-md-6 col-lg-4 col-xl-3' : 'col-12'\">\r\n        <mat-label>CEP Residencial</mat-label>\r\n        <input matInput name=\"cep\" formControlName=\"cep\" placeholder=\"Ex. 00000-000\" [mask]=\"masks.CEP\" [dropSpecialCharacters]=\"false\" autocomplete=\"off\" (change)=\"buscaInfosEndereco()\"/>\r\n        <mat-spinner class=\"spinnerLoading\" [@fadeInOut] *ngIf=\"buscaControler.endereco.buscando\" mat-spinner diameter=\"20\"></mat-spinner>\r\n        <mat-icon class=\"campo-icone\" svgIcon=\"check-circle-outline\" [matTooltip]=\"'CEP v\u00E1lido: ' + buscaControler.endereco.cidade\" *ngIf=\"!buscaControler.endereco.buscando && buscaControler.endereco.status == 'ENCONTROU'\"></mat-icon>\r\n        <mat-icon class=\"campo-icone\" svgIcon=\"alert-circle-outline\" matTooltip=\"N\u00E3o foi poss\u00EDvel validar seu CEP\"\r\n        *ngIf=\"!buscaControler.endereco.buscando && buscaControler.endereco.status == 'NAO-ENCONTROU'\"></mat-icon>\r\n        <mat-error *ngIf=\"formVidaSegurado.get('cep').hasError('pattern')\">Por favor, insira um CEP v\u00E1lido.</mat-error>\r\n        <mat-error *ngIf=\"formVidaSegurado.get('cep').hasError('required')\">Por favor, insira um CEP.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"!habilitar?.SEGURADO_FONE && recalculo\"  [ngClass]=\"!habilitar?.SEGURADO_FONE ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>Telefone</mat-label>\r\n        <input matInput name=\"fone\" formControlName=\"fone\" type=\"tel\" placeholder=\"Ex. (00) 0000-0000\" [mask]=\"maskTelefone\" [dropSpecialCharacters]=\"false\" autocomplete=\"off\" (ngModelChange)=\"alteraMascaraTelefone($event)\"/>\r\n        <mat-error *ngIf=\"formVidaSegurado.get('fone').hasError('pattern') || formVidaSegurado.get('fone').hasError('foneValid')\">\r\n            Por favor, insira um telefone v\u00E1lido.\r\n        </mat-error>\r\n        <mat-error *ngIf=\"formVidaSegurado.get('fone').hasError('required')\">\r\n            Por favor, insira um telefone.\r\n        </mat-error>\r\n        <mat-icon matTooltip=\"Usar o da corretora\" class=\"campo-icone\" svgIcon=\"briefcase-edit\" (click)=\"usarFoneCorretora()\"></mat-icon>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"!habilitar?.SEGURADO_EMAIL && recalculo\"  [ngClass]=\"!habilitar?.SEGURADO_EMAIL ? 'col-12 col-md-12 col-lg-12 col-xl-9' : 'col-12'\">\r\n        <mat-label>Email</mat-label>\r\n        <input name=\"email\" matInput formControlName=\"email\" placeholder=\"Ex. pat@example.com\" autocomplete=\"off\"/>\r\n        <mat-error *ngIf=\"formVidaSegurado.get('email').hasError('email')\">Por favor, insira um e-mail v\u00E1lido</mat-error>\r\n        <mat-error *ngIf=\"formVidaSegurado.get('email').hasError('maxlength')\">O e-mail deve ter no m\u00E1ximo 60 caracteres</mat-error>\r\n        <mat-icon matTooltip=\"Usar o da corretora\" class=\"campo-icone\" svgIcon=\"briefcase-edit\" (click)=\"usarEmailCorretora()\"></mat-icon>\r\n    </mat-form-field>\r\n\r\n    <button tabindex=\"-1\" id=\"submitFormSegurado\" style=\"opacity: 0; position: absolute; z-index: -1000\"></button>\r\n</form>\r\n", styles: [".form-step{padding:0 15px}.form-step .campo-icone{position:absolute;right:0;top:10px;cursor:pointer;color:var(--color-icon)}.form-step .spinnerLoading{position:absolute;right:0;top:10px}.form-step .renda{text-align:left!important}\n"], dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "component", type: i4.MatFormField, selector: "mat-form-field", inputs: ["hideRequiredMarker", "color", "floatLabel", "appearance", "subscriptSizing", "hintLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i4.MatLabel, selector: "mat-label" }, { kind: "directive", type: i4.MatError, selector: "mat-error, [matError]", inputs: ["id"] }, { kind: "component", type: i1$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: i6.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "directive", type: i7.NgxMaskDirective, selector: "input[mask], textarea[mask]", inputs: ["mask", "specialCharacters", "patterns", "prefix", "suffix", "thousandSeparator", "decimalMarker", "dropSpecialCharacters", "hiddenInput", "showMaskTyped", "placeHolderCharacter", "shownMaskExpression", "showTemplate", "clearIfNotMatch", "validation", "separatorLimit", "allowNegativeNumbers", "leadZeroDateTime", "leadZero", "triggerOnMaskChange", "apm", "inputTransformFn", "outputTransformFn", "keepCharacterPositions"], outputs: ["maskFilled"], exportAs: ["mask", "ngxMask"] }, { kind: "component", type: i8.MatSelect, selector: "mat-select", inputs: ["aria-describedby", "panelClass", "disabled", "disableRipple", "tabIndex", "hideSingleSelectionIndicator", "placeholder", "required", "multiple", "disableOptionCentering", "compareWith", "value", "aria-label", "aria-labelledby", "errorStateMatcher", "typeaheadDebounceInterval", "sortComparator", "id", "panelWidth"], outputs: ["openedChange", "opened", "closed", "selectionChange", "valueChange"], exportAs: ["matSelect"] }, { kind: "component", type: i6$1.MatOption, selector: "mat-option", inputs: ["value", "id", "disabled"], outputs: ["onSelectionChange"], exportAs: ["matOption"] }, { kind: "directive", type: i1$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i10.MatProgressSpinner, selector: "mat-progress-spinner, mat-spinner", inputs: ["color", "mode", "value", "diameter", "strokeWidth"], exportAs: ["matProgressSpinner"] }, { kind: "directive", type: i11.MatTooltip, selector: "[matTooltip]", inputs: ["matTooltipPosition", "matTooltipPositionAtOrigin", "matTooltipDisabled", "matTooltipShowDelay", "matTooltipHideDelay", "matTooltipTouchGestures", "matTooltip", "matTooltipClass"], exportAs: ["matTooltip"] }], animations: [trigger('fadeInOut', [transition(':enter', [style({ opacity: 0 }), animate(150, style({ opacity: 1 })),]), transition(':leave', [animate(150, style({ opacity: 0 }))])])] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormularioVidaSeguradoComponent, decorators: [{
            type: Component,
            args: [{ selector: 'formulario-vida-segurado', animations: [trigger('fadeInOut', [transition(':enter', [style({ opacity: 0 }), animate(150, style({ opacity: 1 })),]), transition(':leave', [animate(150, style({ opacity: 0 }))])])], template: "<form class=\"col-12 form-step\"  [formGroup]=\"formVidaSegurado\">\r\n    <mat-form-field [hidden]=\"!habilitar?.SEGURADO_CPFCNPJ && recalculo\" [ngClass]=\"!habilitar?.SEGURADO_CPFCNPJ ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>CPF</mat-label>\r\n        <input matInput name=\"cpf\" formControlName=\"cpf\" placeholder=\"Ex. 000.000.000-00\" autocomplete=\"off\" [mask]=\"masks.CPF\" [dropSpecialCharacters]=\"false\" (blur)=\"buscaInfosSegurado()\"/>\r\n        <mat-spinner class=\"spinnerLoading\" [@fadeInOut] *ngIf=\"buscaControler.segurado.buscando\" mat-spinner diameter=\"20\"></mat-spinner>\r\n        <mat-error *ngIf=\"formVidaSegurado.get('cpf').hasError('validaCpf')\">N\u00FAmero do documento inv\u00E1lido.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"!habilitar?.SEGURADO_NOME && recalculo\" [ngClass]=\"!habilitar?.SEGURADO_NOME ? 'col-12 col-md-6 col-lg-6 col-xl-9' : 'col-12'\">\r\n        <mat-label>Nome completo</mat-label>\r\n        <input matInput name=\"nome\" formControlName=\"nome\" class=\"text-capitalize\" autocomplete=\"off\"/>\r\n        <mat-error *ngIf=\"formVidaSegurado.get('nome').hasError('pattern')\">Por favor, insira nome e sobrenome</mat-error>\r\n        <mat-error *ngIf=\"formVidaSegurado.get('nome').hasError('required')\">Por favor, insira nome e sobrenome</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"!habilitar?.SEGURADO_DATANASC && recalculo\" [ngClass]=\"!habilitar?.SEGURADO_DATANASC ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>Data de Nascimento</mat-label>\r\n        <input matInput name=\"dataNasc\" formControlName=\"dataNasc\" [mask]=\"masks.DATA\" [dropSpecialCharacters]=\"false\" autocomplete=\"off\"/>\r\n        <mat-error *ngIf=\"formVidaSegurado.get('dataNasc').hasError('validaData')\">Data Inv\u00E1lida.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"!habilitar?.SEGURADO_SEXO && recalculo\" [ngClass]=\"!habilitar?.SEGURADO_SEXO ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>Sexo</mat-label>\r\n        <mat-select name=\"sexo\" formControlName=\"sexo\">\r\n            <mat-option *ngFor=\"let s of selects.sexo\" [value]=\"s.value\" [attr.custom-reflect-value]=\"s.value\">\r\n                {{ s.viewValue }}\r\n            </mat-option>\r\n        </mat-select>\r\n        <mat-error *ngIf=\"formVidaSegurado.get('sexo').hasError('required')\">Por favor, selecione um sexo.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"!habilitar?.SEGURADO_ESTADOCIVIL && recalculo\" [ngClass]=\"!habilitar?.SEGURADO_ESTADOCIVIL ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>Estado civil</mat-label>\r\n        <mat-select name=\"estadoCivil\" formControlName=\"estadoCivil\">\r\n            <mat-option *ngFor=\"let e of selects.estadoCivil\" [value]=\"e.value\" [attr.custom-reflect-value]=\"e.value\">\r\n                {{ e.viewValue }}\r\n            </mat-option>\r\n        </mat-select>\r\n        <mat-error *ngIf=\"formVidaSegurado.get('estadoCivil').hasError('required')\">Por favor, selecione um estado civil.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"!habilitar?.SEGURADO_CEP && recalculo\"  [ngClass]=\"!habilitar?.SEGURADO_CEP ? 'col-12 col-md-6 col-lg-4 col-xl-3' : 'col-12'\">\r\n        <mat-label>CEP Residencial</mat-label>\r\n        <input matInput name=\"cep\" formControlName=\"cep\" placeholder=\"Ex. 00000-000\" [mask]=\"masks.CEP\" [dropSpecialCharacters]=\"false\" autocomplete=\"off\" (change)=\"buscaInfosEndereco()\"/>\r\n        <mat-spinner class=\"spinnerLoading\" [@fadeInOut] *ngIf=\"buscaControler.endereco.buscando\" mat-spinner diameter=\"20\"></mat-spinner>\r\n        <mat-icon class=\"campo-icone\" svgIcon=\"check-circle-outline\" [matTooltip]=\"'CEP v\u00E1lido: ' + buscaControler.endereco.cidade\" *ngIf=\"!buscaControler.endereco.buscando && buscaControler.endereco.status == 'ENCONTROU'\"></mat-icon>\r\n        <mat-icon class=\"campo-icone\" svgIcon=\"alert-circle-outline\" matTooltip=\"N\u00E3o foi poss\u00EDvel validar seu CEP\"\r\n        *ngIf=\"!buscaControler.endereco.buscando && buscaControler.endereco.status == 'NAO-ENCONTROU'\"></mat-icon>\r\n        <mat-error *ngIf=\"formVidaSegurado.get('cep').hasError('pattern')\">Por favor, insira um CEP v\u00E1lido.</mat-error>\r\n        <mat-error *ngIf=\"formVidaSegurado.get('cep').hasError('required')\">Por favor, insira um CEP.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"!habilitar?.SEGURADO_FONE && recalculo\"  [ngClass]=\"!habilitar?.SEGURADO_FONE ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>Telefone</mat-label>\r\n        <input matInput name=\"fone\" formControlName=\"fone\" type=\"tel\" placeholder=\"Ex. (00) 0000-0000\" [mask]=\"maskTelefone\" [dropSpecialCharacters]=\"false\" autocomplete=\"off\" (ngModelChange)=\"alteraMascaraTelefone($event)\"/>\r\n        <mat-error *ngIf=\"formVidaSegurado.get('fone').hasError('pattern') || formVidaSegurado.get('fone').hasError('foneValid')\">\r\n            Por favor, insira um telefone v\u00E1lido.\r\n        </mat-error>\r\n        <mat-error *ngIf=\"formVidaSegurado.get('fone').hasError('required')\">\r\n            Por favor, insira um telefone.\r\n        </mat-error>\r\n        <mat-icon matTooltip=\"Usar o da corretora\" class=\"campo-icone\" svgIcon=\"briefcase-edit\" (click)=\"usarFoneCorretora()\"></mat-icon>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"!habilitar?.SEGURADO_EMAIL && recalculo\"  [ngClass]=\"!habilitar?.SEGURADO_EMAIL ? 'col-12 col-md-12 col-lg-12 col-xl-9' : 'col-12'\">\r\n        <mat-label>Email</mat-label>\r\n        <input name=\"email\" matInput formControlName=\"email\" placeholder=\"Ex. pat@example.com\" autocomplete=\"off\"/>\r\n        <mat-error *ngIf=\"formVidaSegurado.get('email').hasError('email')\">Por favor, insira um e-mail v\u00E1lido</mat-error>\r\n        <mat-error *ngIf=\"formVidaSegurado.get('email').hasError('maxlength')\">O e-mail deve ter no m\u00E1ximo 60 caracteres</mat-error>\r\n        <mat-icon matTooltip=\"Usar o da corretora\" class=\"campo-icone\" svgIcon=\"briefcase-edit\" (click)=\"usarEmailCorretora()\"></mat-icon>\r\n    </mat-form-field>\r\n\r\n    <button tabindex=\"-1\" id=\"submitFormSegurado\" style=\"opacity: 0; position: absolute; z-index: -1000\"></button>\r\n</form>\r\n", styles: [".form-step{padding:0 15px}.form-step .campo-icone{position:absolute;right:0;top:10px;cursor:pointer;color:var(--color-icon)}.form-step .spinnerLoading{position:absolute;right:0;top:10px}.form-step .renda{text-align:left!important}\n"] }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: ['api']
                }] }, { type: i1$2.FormBuilder }, { type: FormsService }], propDecorators: { segurados: [{
                type: Input
            }] } });

class TruncarPipe {
    transform(value, limit) {
        if (!value)
            return '';
        if (value.length > limit) {
            return value.substring(0, limit) + '...';
        }
        else {
            return value;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TruncarPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
    static ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: TruncarPipe, name: "truncar" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TruncarPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'truncar'
                }]
        }] });

class CapitalizePipe {
    transform(value) {
        if (!value)
            return '';
        let lowerCaseValue = value.toLowerCase();
        let result = lowerCaseValue.replace(/^[^a-z]*([a-z])/i, (_, letter) => {
            return letter.toUpperCase();
        });
        return result;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CapitalizePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
    static ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CapitalizePipe, name: "capitalize" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CapitalizePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'capitalize'
                }]
        }] });

class FormularioVidaPerfilComponent {
    api;
    formBuilder;
    formsService;
    buscaControler = ConstantFormVida.controlerBusca;
    masks = ConstantFormVida.maskValidate;
    patterns = ConstantFormVida.patternValidade;
    selects = ConstantFormVida.objSelects;
    subscriptions = new Subscription();
    formVidaPerfil;
    profissoes = ConstantFormVida.profissoes;
    profissoesFiltradas;
    esportesRadicais = ConstantFormVida.esportesRadicais;
    esportesFiltrados;
    habilitar = {};
    recalculo = false;
    seguradorasStatus;
    debounceTimers = {};
    profissoesSelecionadas = {};
    profissoesSelecionadasAnterior = {};
    profissoesPorSeguradora = {};
    mensagemProfissaoNaoEncontrada = this.buscaControler.profissoes.mensagens.naoEncontrada;
    mensagemSeguradoraInativa = this.buscaControler.profissoes.mensagens.inativa;
    autoOpened = false;
    set perfil(value) {
        if (value && typeof (value) === 'object' && Object.keys(value).length) {
            this.habilitar = value;
            this.recalculo = true;
        }
    }
    constructor(api, formBuilder, formsService) {
        this.api = api;
        this.formBuilder = formBuilder;
        this.formsService = formsService;
        this.formVidaPerfil = this.formBuilder.group({
            altura: new FormControl('', [Validators.pattern('[0-9]{1}.[0-9]{2}')]),
            peso: new FormControl('', [Validators.pattern('[0-9]{2,3}')]),
            isFumante: new FormControl('', [Validators.required]),
            profissao: new FormControl('', []),
            rendaMensal: new FormControl('', [Validators.required]),
            praticaEsporteRadical: new FormControl('', [Validators.required, FormsService.validateProperty('value', [Validators.required])]),
        });
        this.esportesFiltrados = this.formVidaPerfil.get('praticaEsporteRadical').valueChanges.pipe(startWith(''), map(value => (typeof value === 'string' || value == null ? value : value.viewValue)), map(name => (name ? this._filter(name, this.esportesRadicais) : this.esportesRadicais.slice())));
    }
    ngOnInit() {
        this.inscreverEmiters();
    }
    ngOnDestroy() {
        this.formsService.salvaDraftFinal();
        this.subscriptions.unsubscribe();
    }
    carregaInfosDraft(draft) {
        if (draft && Object.keys(this.formVidaPerfil.controls).length) {
            Object.keys(ConstantFormVida.camposPerfilDraft).forEach(campo => {
                this.formVidaPerfil.controls[campo] &&
                    this.formVidaPerfil.controls[campo].setValue(FormsService.formatField(campo, draft?.segurado?.[ConstantFormVida.camposPerfilDraft[campo]]));
            });
            this.formVidaPerfil.controls.isFumante.setValue(draft?.configuracoes?.fumante);
            this.formVidaPerfil.controls.praticaEsporteRadical.setValue(FormsService.formatField('praticaEsporteRadical', draft?.configuracoes?.praticaEsporteRadical));
            if (draft?.segurado.hasOwnProperty('profissaoTxt'))
                this.formVidaPerfil.controls.profissao.setValue(draft.segurado.profissaoTxt);
            if (draft?.hasOwnProperty('buscaPorSeguradora'))
                this.profissoesSelecionadas = draft.buscaPorSeguradora;
        }
    }
    displayFn(offer) {
        return offer && offer.viewValue ? offer.viewValue : undefined;
    }
    displayFnWrapper() {
        return offer => this.displayFn(offer);
    }
    _filter(viewValueStr, options) {
        const filterValue = viewValueStr.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
        return options.filter(option => option.viewValue.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "").indexOf(filterValue) === 0);
    }
    inscreverEmiters() {
        this.subscriptions.add(this.formsService.resetaFormularioEmiter.subscribe(() => {
            this.formVidaPerfil.reset();
        }));
        this.subscriptions.add(this.formVidaPerfil?.valueChanges.subscribe(() => {
            this.formsService.enviaValidadeFormulario({ formularioNome: 'perfil', valido: this.formVidaPerfil.valid });
        }));
        this.subscriptions.add(this.formsService.preencheFormularioEmiter.subscribe(draft => {
            this.carregaInfosDraft(draft);
            this.setFilters(this.profissoesPorSeguradora);
        }));
        this.subscriptions.add(this.formsService.setarInfosDefaultEmiter.subscribe(() => {
            this.formsService.setaInfosDefault(this.formVidaPerfil, 'perfil');
            this.setFilters(this.profissoesPorSeguradora);
        }));
        this.subscriptions.add(this.formsService.preencheDraftEmiter.subscribe(draft => {
            this.preencheDraft(draft);
        }));
        this.subscriptions.add(this.formsService.seguradorasStatusEmiter.subscribe(seguradorasStatus => {
            this.seguradorasStatus = seguradorasStatus;
            this.geraOptionsProfissaoPorSeguradora();
        }));
    }
    limparCampo(nomeCampo) {
        this.formVidaPerfil.controls[nomeCampo].reset();
    }
    preencheDraft(draft) {
        try {
            if (draft && Object.keys(this.formVidaPerfil?.controls).length) {
                Object.keys(ConstantFormVida.camposPerfilDraft).forEach(campo => {
                    draft.segurado[ConstantFormVida.camposPerfilDraft[campo]] = FormsService.formatFieldToDraft(campo, this.formVidaPerfil.controls[campo].value);
                });
                draft.configuracoes.fumante = this.formVidaPerfil.controls.isFumante.value;
                draft.configuracoes.praticaEsporteRadical = FormsService.formatFieldToDraft('praticaEsporteRadical', this.formVidaPerfil.controls.praticaEsporteRadical.value);
                if (Object.keys(this.profissoesSelecionadas).length > 0)
                    draft.buscaPorSeguradora = { profissao: this.profissoesSelecionadas };
            }
        }
        catch (error) {
            return false;
        }
    }
    selecionarProfissao(profissao, seguradoraId) {
        if (profissao.Value !== this.mensagemProfissaoNaoEncontrada && profissao.Value !== this.mensagemSeguradoraInativa) {
            this.profissoesSelecionadas[seguradoraId] = profissao;
        }
    }
    removerProfissao(seguradoraId) {
        delete this.profissoesSelecionadas[seguradoraId];
        this.verificaProfissaoSelecionada();
        this.formVidaPerfil.controls.profissao.markAsTouched();
    }
    profissaoSelecionada(nomeProfissao, seguradoraId, anterior) {
        const variavelASerVerificada = anterior ? 'profissoesSelecionadasAnterior' : 'profissoesSelecionadas';
        return this[variavelASerVerificada][seguradoraId]?.Value === nomeProfissao;
    }
    async geraOptionsProfissaoPorSeguradora() {
        if (!this.seguradorasStatus)
            return;
        this.selects.profissoes = [];
        const createProfissao = (seguradora, ativa, profissoes) => ({
            seguradoraId: seguradora.seguradora,
            seguradora: seguradora.nome,
            imagem: this.formsService.getPathLogoById(seguradora.seguradora),
            ativa,
            profissoes,
            showAll: false
        });
        for (const seguradora of this.seguradorasStatus.habilitadas)
            this.selects.profissoes.push(createProfissao(seguradora, true, []));
        for (const seguradora of this.seguradorasStatus.desabilitadas)
            this.selects.profissoes.push(createProfissao(seguradora, false, [{ Value: this.mensagemSeguradoraInativa }]));
    }
    preencheProfissoesSelecionadas(calculos) {
        try {
            for (const calculo of calculos) {
                if (calculo.hasOwnProperty('valoresAjusteSeguradora') && calculo.valoresAjusteSeguradora.hasOwnProperty('profissao')) {
                    if (this.seguradorasStatus && this.seguradorasStatus.habilitadas.find(s => s.seguradora === calculo.seguradora)) {
                        this.selecionarProfissao(calculo.valoresAjusteSeguradora.profissao, calculo.seguradora);
                    }
                }
            }
        }
        catch (error) {
            return false;
        }
        this.verificaProfissaoSelecionada();
    }
    debounce(fn, id, timeout) {
        clearTimeout(this.debounceTimers[id]);
        this.debounceTimers[id] = setTimeout(fn, timeout);
    }
    getObjectKeys(obj) {
        return Object.keys(obj);
    }
    toggleShowAll(group) {
        group.showAll = !group.showAll;
    }
    buscaProfissoes() {
        const buscaAtual = this.formVidaPerfil.controls.profissao.value;
        const KeyValueNaoEncontrada = [{ Value: this.mensagemProfissaoNaoEncontrada, Key: this.mensagemSeguradoraInativa }];
        const KeyValueInativa = [{ Value: this.mensagemSeguradoraInativa, Key: this.mensagemSeguradoraInativa }];
        this.debounce(() => {
            if (buscaAtual.length >= 3 && buscaAtual !== this.buscaControler.profissoes.ultimaBusca) {
                this.buscaControler.profissoes.ultimaBusca = buscaAtual;
                this.buscaControler.profissoes.buscando = true;
                this.api.getOptionsBySegFull(ConstantFormVida.executionType, buscaAtual).then(function (profissoes) {
                    if (profissoes && profissoes?.length) {
                        for (const profissao of profissoes) {
                            const seguradoraId = profissao.seguradora;
                            const profissaoSeguradora = this.selects.profissoes.find(s => s.seguradoraId === seguradoraId);
                            if (profissaoSeguradora) {
                                if (profissaoSeguradora.ativa) {
                                    if (profissao.KeyValue && profissao.KeyValue.length) {
                                        this.profissoesPorSeguradora[seguradoraId] = this.profissoesSelecionadas[seguradoraId] ?
                                            [this.profissoesSelecionadas[seguradoraId]].concat(profissao.KeyValue) : profissao.KeyValue;
                                    }
                                    else {
                                        this.profissoesPorSeguradora[seguradoraId] = this.profissoesSelecionadas[seguradoraId] ?
                                            [this.profissoesSelecionadas[seguradoraId]].concat(KeyValueNaoEncontrada) : KeyValueNaoEncontrada;
                                    }
                                }
                                else {
                                    this.profissoesPorSeguradora[seguradoraId] = KeyValueInativa;
                                }
                                this.profissoesPorSeguradora[seguradoraId] = this.formsService.removeOpcoesRepetidas(this.profissoesPorSeguradora[seguradoraId]);
                            }
                        }
                    }
                    this.setFilters(this.profissoesPorSeguradora);
                    this.buscaControler.profissoes.buscando = false;
                }.bind(this)).catch(async function (e) {
                    this.buscaControler.profissoes.buscando = false;
                }.bind(this));
            }
            else {
                this.setFilters(this.profissoesPorSeguradora);
            }
        }, 'profissoes-seguradora', 350);
    }
    setFilters(profissoes) {
        this.profissoesFiltradas = (this.formVidaPerfil.controls.profissao?.valueChanges.pipe(startWith(''), map(value => this._filterGroup(value || '', profissoes))));
    }
    _filterGroup(value, profissoes) {
        return this.selects.profissoes ? this.selects.profissoes.map(group => ({
            seguradoraId: group.seguradoraId,
            seguradora: group.seguradora,
            profissoes: value ? this.buscaProfissoes() : profissoes[group.seguradoraId],
            imagem: group.imagem,
            ativa: group.ativa,
            showAll: group.showAll
        })).filter(group => group.profissoes && group.profissoes.length).filter(() => !this.buscaControler.profissoes.buscando) : [];
    }
    displayFnProfissao(state) {
        return state;
    }
    onAutocompleteOpened() {
        this.autoOpened = true;
        for (const group of this.selects.profissoes) {
            this.profissoesSelecionadasAnterior[group.seguradoraId] = this.profissoesSelecionadas[group.seguradoraId];
        }
    }
    profissoesVisiveis(group) {
        const compareProfissoes = (a, b) => {
            const aSelecionada = this.profissaoSelecionada(a.Value, group.seguradoraId, true);
            const bSelecionada = this.profissaoSelecionada(b.Value, group.seguradoraId, true);
            return aSelecionada === bSelecionada ? 0 : aSelecionada ? -1 : 1;
        };
        return group.profissoes && group.profissoes.length ?
            (group.showAll ? group.profissoes.sort(compareProfissoes) :
                (this.profissoesSelecionadasAnterior[group.seguradoraId] ?
                    group.profissoes.sort(compareProfissoes).slice(0, 4) :
                    group.profissoes.sort(compareProfissoes).slice(0, 3))) : [];
    }
    verificaProfissaoSelecionada() {
        if (Object.keys(this.profissoesSelecionadas).length == 0 && !this.autoOpened) {
            this.formVidaPerfil.controls.profissao.setErrors({ 'invalid': true });
        }
        else {
            this.formVidaPerfil.controls.profissao.setErrors(null);
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormularioVidaPerfilComponent, deps: [{ token: 'api' }, { token: i1$2.FormBuilder }, { token: FormsService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: FormularioVidaPerfilComponent, selector: "formulario-vida-perfil", inputs: { perfil: "perfil" }, ngImport: i0, template: "<form class=\"col-12 form-step\"  [formGroup]=\"formVidaPerfil\">\r\n\r\n    <mat-form-field [hidden]=\"!habilitar?.SEGURADO_ALTURA && recalculo\"  [ngClass]=\"!habilitar?.SEGURADO_ALTURA ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>Altura (m)</mat-label>\r\n        <input matInput name=\"altura\" formControlName=\"altura\" [mask]=\"masks.ALTURA\" [dropSpecialCharacters]=\"false\" autocomplete=\"off\"/>\r\n        <mat-error *ngIf=\"formVidaPerfil.get('altura').hasError('pattern')\">Informe uma altura v\u00E1lida</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"!habilitar?.SEGURADO_PESO && recalculo\"  [ngClass]=\"!habilitar?.SEGURADO_PESO ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>Peso (kg)</mat-label>\r\n        <input matInput name=\"peso\" formControlName=\"peso\" [mask]=\"masks.PESO\" [dropSpecialCharacters]=\"false\" autocomplete=\"off\"/>\r\n        <mat-error *ngIf=\"formVidaPerfil.get('peso').hasError('pattern')\">Informe um peso v\u00E1lido</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"!habilitar?.SEGURADO_FUMANTE && recalculo\"  [ngClass]=\"!habilitar?.SEGURADO_FUMANTE ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>Fumante</mat-label>\r\n        <mat-select name=\"isFumante\" formControlName=\"isFumante\">\r\n            <mat-option *ngFor=\"let s of selects.simOuNao\" [value]=\"s.value\" [attr.custom-reflect-value]=\"s.value\">\r\n                {{ s.viewValue }}\r\n            </mat-option>\r\n        </mat-select>\r\n        <mat-error *ngIf=\"formVidaPerfil.get('isFumante').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"!habilitar?.SEGURADO_RENDAMENSAL && recalculo\"  [ngClass]=\"!habilitar?.SEGURADO_RENDAMENSAL ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>Renda Mensal</mat-label>\r\n        <input class=\"renda\" matInput type=\"text\" name=\"rendaMensal\" formControlName=\"rendaMensal\" currencyMask [options]=\"{ prefix: 'R$ ', thousands: '.', decimal: ',' }\"/>\r\n        <mat-error *ngIf=\"formVidaPerfil.get('rendaMensal').hasError('required')\">Por favor, digite sua renda.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"!habilitar?.SEGURADO_PROFISSAO && recalculo\"  [ngClass]=\"!habilitar?.SEGURADO_PROFISSAO ? 'col-12 col-md-6 col-lg-6 col-xl-6' : 'col-12'\" class=\"chip-form-field\">\r\n        <mat-label>Busca por profiss\u00E3o*</mat-label>\r\n        <input tab-directive type=\"text\" aria-label=\"Profiss\u00E3o\" matInput [matAutocomplete]=\"auto\" formControlName=\"profissao\"  [matChipInputFor]=\"chipProfissao\" (focusout)=\"verificaProfissaoSelecionada()\"/>\r\n        <mat-autocomplete [displayWith]=\"displayFnProfissao\" #auto=\"matAutocomplete\" class=\"autocomplete-busca-profissao\" classList=\"autocomplete-busca-profissao\" (opened)=\"onAutocompleteOpened()\" (closed)=\"autoOpened = false;verificaProfissaoSelecionada()\">\r\n            <mat-optgroup *ngFor=\"let group of profissoesFiltradas | async\" [label]=\"group.seguradora\" class=\"opt-group-com-logo\"\r\n                [ngClass]=\"group.ativa ? 'seguradora-ativa' : 'seguradora-inativa'\">\r\n                <img class=\"logo-seguradora\" [src]=\"group.imagem\" [alt]=\"group.seguradora\">\r\n                <ng-container *ngFor=\"let profissao of profissoesVisiveis(group)\">\r\n                <mat-option [value]=\"profissao\" [disabled]=\"profissao.Value === mensagemProfissaoNaoEncontrada || profissao.Value === mensagemSeguradoraInativa\">\r\n                    <div (click)=\"$event.stopPropagation();selecionarProfissao(profissao, group.seguradoraId)\" class=\"container-selecao\">\r\n                    <input type=\"radio\" [checked]=\"profissaoSelecionada(profissao.Value, group.seguradoraId)\" \r\n                        *ngIf=\"profissao.Value !== mensagemProfissaoNaoEncontrada && profissao.Value !== mensagemSeguradoraInativa\">\r\n                    <span [ngClass]=\"profissao.Value === mensagemProfissaoNaoEncontrada || profissao.Value === mensagemSeguradoraInativa ? 'sem-opcao' : ''\">\r\n                        {{profissao.Value | capitalize}}\r\n                    </span>\r\n                    </div>\r\n                </mat-option>\r\n                </ng-container>\r\n                <mat-option class=\"opt-btn-ver-todos\" *ngIf=\"group.profissoes && (profissoesSelecionadas[group.seguradoraId] && group.profissoes.length > 4 || !profissoesSelecionadas[group. seguradoraId] && group.profissoes.length > 3)\" disabled=\"true\">\r\n                <div (click)=\"$event.stopPropagation();toggleShowAll(group)\" class=\"container-selecao\">\r\n                    <span class=\"mostrar-todas\">\r\n                    {{ group.showAll ? 'Ver menos' : 'Ver todas' }}\r\n                    </span>\r\n                </div>\r\n                </mat-option>\r\n            </mat-optgroup>\r\n        </mat-autocomplete>\r\n        <mat-icon class=\"segundo-icone\" (click)=\"limparCampo('profissao')\" *ngIf=\"!buscaControler.profissoes.buscando\" \r\n            [svgIcon]=\"formVidaPerfil.controls.profissao.value ? 'window-close' : 'magnify'\" >\r\n        </mat-icon>\r\n        <mat-spinner class=\"spinnerLoading\" [@fadeInOut] *ngIf=\"buscaControler.profissoes.buscando\" mat-spinner diameter=\"20\"></mat-spinner>\r\n        <mat-error *ngIf=\"formVidaPerfil.get('profissao').hasError('invalidProperty')\">Por favor, selecione uma profiss\u00E3o.</mat-error>\r\n        <mat-error *ngIf=\"formVidaPerfil.get('profissao').hasError('invalid')\">Selecione a profiss\u00E3o em todas seguradoras que deseja cotar.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"recalculo && !habilitar?.CONFIGURACOES_ISESPORTE\" [ngClass]=\"!habilitar?.CONFIGURACOES_ISESPORTE ? 'col-12 col-md-6 col-lg-6 col-xl-3': 'col-12'\">\r\n        <mat-label>Pratica esportes radicais</mat-label>\r\n        <input tab-directive type=\"text\" aria-label=\"Pratica esportes radicais\" matInput [matAutocomplete]=\"autoEsporteRadical\" formControlName=\"praticaEsporteRadical\"/>\r\n        <mat-autocomplete [displayWith]=\"displayFnWrapper()\" #autoEsporteRadical=\"matAutocomplete\">\r\n          <mat-option class=\"autoComplete\" *ngFor=\"let esporte of esportesFiltrados | async\" [value]=\"esporte\">\r\n            {{ esporte.viewValue }}\r\n          </mat-option>\r\n        </mat-autocomplete>\r\n        <mat-icon matTooltip=\"Limpar Esporte Radical\" class=\"campo-icone\" svgIcon=\"delete\" (click)=\"limparCampo('praticaEsporteRadical')\"></mat-icon>\r\n        <mat-error *ngIf=\"formVidaPerfil.get('praticaEsporteRadical').hasError('invalidProperty')\">Por favor, selecione um esporte radical.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-chip-grid #chipProfissao [hidden]=\"!habilitar?.SEGURADO_PROFISSAO && recalculo\">\r\n        <mat-chip-row *ngFor=\"let seguradora of getObjectKeys(profissoesSelecionadas)\" (removed)=\"removerProfissao(seguradora)\" \r\n          [matTooltip]=\"profissoesSelecionadas[seguradora].Value | capitalize\" [matTooltipDisabled]=\"profissoesSelecionadas[seguradora].Value.length <= 27\">\r\n          <img class=\"logo-seguradora\" [src]=\"formsService.getPathLogoById(seguradora)\">\r\n          <span>{{ profissoesSelecionadas[seguradora].Value | truncar:28 | capitalize }}</span>\r\n          <button matChipRemove [attr.aria-label]=\"'remove-profissao-seg-' + seguradora\">\r\n            <mat-icon>cancel</mat-icon>\r\n          </button>\r\n        </mat-chip-row>\r\n      </mat-chip-grid>\r\n\r\n    <button (click)=\"verificaProfissaoSelecionada()\" tabindex=\"-1\" id=\"submitFormPerfil\" style=\"opacity: 0; position: absolute; z-index: -1000\"></button>\r\n</form>\r\n", styles: [".form-step{padding:0 15px}.form-step .campo-icone{position:absolute;right:0;top:10px;cursor:pointer;color:var(--color-icon)}.form-step .segundo-icone{position:absolute;right:0;top:10px;cursor:pointer;color:var(--color-icon);width:21px;height:21px;display:flex}.form-step .spinnerLoading{position:absolute;right:0;top:10px}.form-step .renda{text-align:left!important}\n"], dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "component", type: i4.MatFormField, selector: "mat-form-field", inputs: ["hideRequiredMarker", "color", "floatLabel", "appearance", "subscriptSizing", "hintLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i4.MatLabel, selector: "mat-label" }, { kind: "directive", type: i4.MatError, selector: "mat-error, [matError]", inputs: ["id"] }, { kind: "component", type: i5.MatAutocomplete, selector: "mat-autocomplete", inputs: ["aria-label", "aria-labelledby", "displayWith", "autoActiveFirstOption", "autoSelectActiveOption", "requireSelection", "panelWidth", "disableRipple", "class", "hideSingleSelectionIndicator"], outputs: ["optionSelected", "opened", "closed", "optionActivated"], exportAs: ["matAutocomplete"] }, { kind: "component", type: i6$1.MatOption, selector: "mat-option", inputs: ["value", "id", "disabled"], outputs: ["onSelectionChange"], exportAs: ["matOption"] }, { kind: "component", type: i6$1.MatOptgroup, selector: "mat-optgroup", inputs: ["label", "disabled"], exportAs: ["matOptgroup"] }, { kind: "directive", type: i5.MatAutocompleteTrigger, selector: "input[matAutocomplete], textarea[matAutocomplete]", inputs: ["matAutocomplete", "matAutocompletePosition", "matAutocompleteConnectedTo", "autocomplete", "matAutocompleteDisabled"], exportAs: ["matAutocompleteTrigger"] }, { kind: "component", type: i1$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: i11.MatTooltip, selector: "[matTooltip]", inputs: ["matTooltipPosition", "matTooltipPositionAtOrigin", "matTooltipDisabled", "matTooltipShowDelay", "matTooltipHideDelay", "matTooltipTouchGestures", "matTooltip", "matTooltipClass"], exportAs: ["matTooltip"] }, { kind: "directive", type: i9.NgxCurrencyDirective, selector: "[currencyMask]", inputs: ["options"] }, { kind: "directive", type: i6.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "directive", type: i7.NgxMaskDirective, selector: "input[mask], textarea[mask]", inputs: ["mask", "specialCharacters", "patterns", "prefix", "suffix", "thousandSeparator", "decimalMarker", "dropSpecialCharacters", "hiddenInput", "showMaskTyped", "placeHolderCharacter", "shownMaskExpression", "showTemplate", "clearIfNotMatch", "validation", "separatorLimit", "allowNegativeNumbers", "leadZeroDateTime", "leadZero", "triggerOnMaskChange", "apm", "inputTransformFn", "outputTransformFn", "keepCharacterPositions"], outputs: ["maskFilled"], exportAs: ["mask", "ngxMask"] }, { kind: "component", type: i8.MatSelect, selector: "mat-select", inputs: ["aria-describedby", "panelClass", "disabled", "disableRipple", "tabIndex", "hideSingleSelectionIndicator", "placeholder", "required", "multiple", "disableOptionCentering", "compareWith", "value", "aria-label", "aria-labelledby", "errorStateMatcher", "typeaheadDebounceInterval", "sortComparator", "id", "panelWidth"], outputs: ["openedChange", "opened", "closed", "selectionChange", "valueChange"], exportAs: ["matSelect"] }, { kind: "directive", type: i1$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i13.MatChipGrid, selector: "mat-chip-grid", inputs: ["disabled", "placeholder", "required", "value", "errorStateMatcher"], outputs: ["change", "valueChange"] }, { kind: "directive", type: i13.MatChipInput, selector: "input[matChipInputFor]", inputs: ["matChipInputFor", "matChipInputAddOnBlur", "matChipInputSeparatorKeyCodes", "placeholder", "id", "disabled"], outputs: ["matChipInputTokenEnd"], exportAs: ["matChipInput", "matChipInputFor"] }, { kind: "directive", type: i13.MatChipRemove, selector: "[matChipRemove]" }, { kind: "component", type: i13.MatChipRow, selector: "mat-chip-row, [mat-chip-row], mat-basic-chip-row, [mat-basic-chip-row]", inputs: ["editable"], outputs: ["edited"] }, { kind: "component", type: i10.MatProgressSpinner, selector: "mat-progress-spinner, mat-spinner", inputs: ["color", "mode", "value", "diameter", "strokeWidth"], exportAs: ["matProgressSpinner"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }, { kind: "pipe", type: TruncarPipe, name: "truncar" }, { kind: "pipe", type: CapitalizePipe, name: "capitalize" }], animations: [trigger('fadeInOut', [transition(':enter', [style({ opacity: 0 }), animate(150, style({ opacity: 1 })),]), transition(':leave', [animate(150, style({ opacity: 0 }))])])] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormularioVidaPerfilComponent, decorators: [{
            type: Component,
            args: [{ selector: 'formulario-vida-perfil', animations: [trigger('fadeInOut', [transition(':enter', [style({ opacity: 0 }), animate(150, style({ opacity: 1 })),]), transition(':leave', [animate(150, style({ opacity: 0 }))])])], template: "<form class=\"col-12 form-step\"  [formGroup]=\"formVidaPerfil\">\r\n\r\n    <mat-form-field [hidden]=\"!habilitar?.SEGURADO_ALTURA && recalculo\"  [ngClass]=\"!habilitar?.SEGURADO_ALTURA ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>Altura (m)</mat-label>\r\n        <input matInput name=\"altura\" formControlName=\"altura\" [mask]=\"masks.ALTURA\" [dropSpecialCharacters]=\"false\" autocomplete=\"off\"/>\r\n        <mat-error *ngIf=\"formVidaPerfil.get('altura').hasError('pattern')\">Informe uma altura v\u00E1lida</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"!habilitar?.SEGURADO_PESO && recalculo\"  [ngClass]=\"!habilitar?.SEGURADO_PESO ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>Peso (kg)</mat-label>\r\n        <input matInput name=\"peso\" formControlName=\"peso\" [mask]=\"masks.PESO\" [dropSpecialCharacters]=\"false\" autocomplete=\"off\"/>\r\n        <mat-error *ngIf=\"formVidaPerfil.get('peso').hasError('pattern')\">Informe um peso v\u00E1lido</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"!habilitar?.SEGURADO_FUMANTE && recalculo\"  [ngClass]=\"!habilitar?.SEGURADO_FUMANTE ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>Fumante</mat-label>\r\n        <mat-select name=\"isFumante\" formControlName=\"isFumante\">\r\n            <mat-option *ngFor=\"let s of selects.simOuNao\" [value]=\"s.value\" [attr.custom-reflect-value]=\"s.value\">\r\n                {{ s.viewValue }}\r\n            </mat-option>\r\n        </mat-select>\r\n        <mat-error *ngIf=\"formVidaPerfil.get('isFumante').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"!habilitar?.SEGURADO_RENDAMENSAL && recalculo\"  [ngClass]=\"!habilitar?.SEGURADO_RENDAMENSAL ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n        <mat-label>Renda Mensal</mat-label>\r\n        <input class=\"renda\" matInput type=\"text\" name=\"rendaMensal\" formControlName=\"rendaMensal\" currencyMask [options]=\"{ prefix: 'R$ ', thousands: '.', decimal: ',' }\"/>\r\n        <mat-error *ngIf=\"formVidaPerfil.get('rendaMensal').hasError('required')\">Por favor, digite sua renda.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"!habilitar?.SEGURADO_PROFISSAO && recalculo\"  [ngClass]=\"!habilitar?.SEGURADO_PROFISSAO ? 'col-12 col-md-6 col-lg-6 col-xl-6' : 'col-12'\" class=\"chip-form-field\">\r\n        <mat-label>Busca por profiss\u00E3o*</mat-label>\r\n        <input tab-directive type=\"text\" aria-label=\"Profiss\u00E3o\" matInput [matAutocomplete]=\"auto\" formControlName=\"profissao\"  [matChipInputFor]=\"chipProfissao\" (focusout)=\"verificaProfissaoSelecionada()\"/>\r\n        <mat-autocomplete [displayWith]=\"displayFnProfissao\" #auto=\"matAutocomplete\" class=\"autocomplete-busca-profissao\" classList=\"autocomplete-busca-profissao\" (opened)=\"onAutocompleteOpened()\" (closed)=\"autoOpened = false;verificaProfissaoSelecionada()\">\r\n            <mat-optgroup *ngFor=\"let group of profissoesFiltradas | async\" [label]=\"group.seguradora\" class=\"opt-group-com-logo\"\r\n                [ngClass]=\"group.ativa ? 'seguradora-ativa' : 'seguradora-inativa'\">\r\n                <img class=\"logo-seguradora\" [src]=\"group.imagem\" [alt]=\"group.seguradora\">\r\n                <ng-container *ngFor=\"let profissao of profissoesVisiveis(group)\">\r\n                <mat-option [value]=\"profissao\" [disabled]=\"profissao.Value === mensagemProfissaoNaoEncontrada || profissao.Value === mensagemSeguradoraInativa\">\r\n                    <div (click)=\"$event.stopPropagation();selecionarProfissao(profissao, group.seguradoraId)\" class=\"container-selecao\">\r\n                    <input type=\"radio\" [checked]=\"profissaoSelecionada(profissao.Value, group.seguradoraId)\" \r\n                        *ngIf=\"profissao.Value !== mensagemProfissaoNaoEncontrada && profissao.Value !== mensagemSeguradoraInativa\">\r\n                    <span [ngClass]=\"profissao.Value === mensagemProfissaoNaoEncontrada || profissao.Value === mensagemSeguradoraInativa ? 'sem-opcao' : ''\">\r\n                        {{profissao.Value | capitalize}}\r\n                    </span>\r\n                    </div>\r\n                </mat-option>\r\n                </ng-container>\r\n                <mat-option class=\"opt-btn-ver-todos\" *ngIf=\"group.profissoes && (profissoesSelecionadas[group.seguradoraId] && group.profissoes.length > 4 || !profissoesSelecionadas[group. seguradoraId] && group.profissoes.length > 3)\" disabled=\"true\">\r\n                <div (click)=\"$event.stopPropagation();toggleShowAll(group)\" class=\"container-selecao\">\r\n                    <span class=\"mostrar-todas\">\r\n                    {{ group.showAll ? 'Ver menos' : 'Ver todas' }}\r\n                    </span>\r\n                </div>\r\n                </mat-option>\r\n            </mat-optgroup>\r\n        </mat-autocomplete>\r\n        <mat-icon class=\"segundo-icone\" (click)=\"limparCampo('profissao')\" *ngIf=\"!buscaControler.profissoes.buscando\" \r\n            [svgIcon]=\"formVidaPerfil.controls.profissao.value ? 'window-close' : 'magnify'\" >\r\n        </mat-icon>\r\n        <mat-spinner class=\"spinnerLoading\" [@fadeInOut] *ngIf=\"buscaControler.profissoes.buscando\" mat-spinner diameter=\"20\"></mat-spinner>\r\n        <mat-error *ngIf=\"formVidaPerfil.get('profissao').hasError('invalidProperty')\">Por favor, selecione uma profiss\u00E3o.</mat-error>\r\n        <mat-error *ngIf=\"formVidaPerfil.get('profissao').hasError('invalid')\">Selecione a profiss\u00E3o em todas seguradoras que deseja cotar.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"recalculo && !habilitar?.CONFIGURACOES_ISESPORTE\" [ngClass]=\"!habilitar?.CONFIGURACOES_ISESPORTE ? 'col-12 col-md-6 col-lg-6 col-xl-3': 'col-12'\">\r\n        <mat-label>Pratica esportes radicais</mat-label>\r\n        <input tab-directive type=\"text\" aria-label=\"Pratica esportes radicais\" matInput [matAutocomplete]=\"autoEsporteRadical\" formControlName=\"praticaEsporteRadical\"/>\r\n        <mat-autocomplete [displayWith]=\"displayFnWrapper()\" #autoEsporteRadical=\"matAutocomplete\">\r\n          <mat-option class=\"autoComplete\" *ngFor=\"let esporte of esportesFiltrados | async\" [value]=\"esporte\">\r\n            {{ esporte.viewValue }}\r\n          </mat-option>\r\n        </mat-autocomplete>\r\n        <mat-icon matTooltip=\"Limpar Esporte Radical\" class=\"campo-icone\" svgIcon=\"delete\" (click)=\"limparCampo('praticaEsporteRadical')\"></mat-icon>\r\n        <mat-error *ngIf=\"formVidaPerfil.get('praticaEsporteRadical').hasError('invalidProperty')\">Por favor, selecione um esporte radical.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-chip-grid #chipProfissao [hidden]=\"!habilitar?.SEGURADO_PROFISSAO && recalculo\">\r\n        <mat-chip-row *ngFor=\"let seguradora of getObjectKeys(profissoesSelecionadas)\" (removed)=\"removerProfissao(seguradora)\" \r\n          [matTooltip]=\"profissoesSelecionadas[seguradora].Value | capitalize\" [matTooltipDisabled]=\"profissoesSelecionadas[seguradora].Value.length <= 27\">\r\n          <img class=\"logo-seguradora\" [src]=\"formsService.getPathLogoById(seguradora)\">\r\n          <span>{{ profissoesSelecionadas[seguradora].Value | truncar:28 | capitalize }}</span>\r\n          <button matChipRemove [attr.aria-label]=\"'remove-profissao-seg-' + seguradora\">\r\n            <mat-icon>cancel</mat-icon>\r\n          </button>\r\n        </mat-chip-row>\r\n      </mat-chip-grid>\r\n\r\n    <button (click)=\"verificaProfissaoSelecionada()\" tabindex=\"-1\" id=\"submitFormPerfil\" style=\"opacity: 0; position: absolute; z-index: -1000\"></button>\r\n</form>\r\n", styles: [".form-step{padding:0 15px}.form-step .campo-icone{position:absolute;right:0;top:10px;cursor:pointer;color:var(--color-icon)}.form-step .segundo-icone{position:absolute;right:0;top:10px;cursor:pointer;color:var(--color-icon);width:21px;height:21px;display:flex}.form-step .spinnerLoading{position:absolute;right:0;top:10px}.form-step .renda{text-align:left!important}\n"] }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: ['api']
                }] }, { type: i1$2.FormBuilder }, { type: FormsService }], propDecorators: { perfil: [{
                type: Input
            }] } });

class FormularioVidaCoberturasComponent {
    formBuilder;
    formsService;
    selects = ConstantFormVida.objSelects;
    subscriptions = new Subscription();
    formVidaCoberturas;
    filds = [];
    replicarCoberturas = [
        { cob: 'isAppMorteAcidental', naoAlterar: false },
        { cob: 'isAppInvalidez', naoAlterar: false },
        { cob: 'isInvalidezDoenca', naoAlterar: false },
    ];
    coberturas;
    recalculo = false;
    set tipo(value) {
        this.recalculo = value;
    }
    set campos(value) {
        this.filds = value;
    }
    set cobertura(value) {
        if (value && typeof (value) === 'object' && Object.keys(value).length) {
            this.coberturas = value;
            this.recalculo = true;
        }
    }
    constructor(formBuilder, formsService) {
        this.formBuilder = formBuilder;
        this.formsService = formsService;
        let assistMorte = new FormControl(50000, [Validators.required]);
        this.formVidaCoberturas = this.formBuilder.group({
            assistMorte,
            isAppMorteAcidental: new FormControl(0, [Validators.required]),
            isAppInvalidez: new FormControl(0, [Validators.required]),
            assistFuneral: new FormControl(0, [Validators.required]),
            isDespesasMedicasHospitalares: new FormControl(0, [Validators.required]),
            isInvalidezDoenca: new FormControl(0, [Validators.required]),
            valorDIT: new FormControl(0, [Validators.required]),
            valorDoencasGraves: new FormControl(0, [Validators.required, FormsService.validaValorDoencasGraves(assistMorte)]),
        });
    }
    ngOnInit() {
        this.inscreverEmiters();
        this.setViewValue();
    }
    setViewValue() {
        if (!this.selects.valoresCoberturasObrigatorias[0].interval)
            return;
        this.selects.valoresCoberturasObrigatorias = this.formsService.intervalNumberToViewValue(this.selects.valoresCoberturasObrigatorias);
        this.selects.valoresCoberturasOpcionais = this.formsService.intervalNumberToViewValue(this.selects.valoresCoberturasOpcionais);
        this.selects.valoresDIT = this.formsService.intervalNumberToViewValue(this.selects.valoresDIT);
        this.selects.valoresDIH = this.formsService.intervalNumberToViewValue(this.selects.valoresDIH);
    }
    ngOnDestroy() {
        this.formsService.salvaDraftFinal();
        this.subscriptions.unsubscribe();
    }
    carregaInfosDraft(draft) {
        if (draft && Object.keys(this.formVidaCoberturas.controls).length) {
            Object.keys(ConstantFormVida.camposCoberturasDraft).forEach(campo => {
                this.formVidaCoberturas.controls[campo] &&
                    this.formVidaCoberturas.controls[campo].setValue(FormsService.formatField(campo, draft?.configuracoes?.[ConstantFormVida.camposCoberturasDraft[campo]]));
            });
            this.replicarCoberturas.forEach(cob => {
                cob.naoAlterar = true;
            });
        }
    }
    inscreverEmiters() {
        this.subscriptions.add(this.formsService.preencheFormularioEmiter.subscribe(draft => {
            if (this.formsService.isVendaCruzada(draft))
                this.formsService.setaInfosDefault(this.formVidaCoberturas, 'coberturas');
            else
                this.carregaInfosDraft(draft);
        }));
        this.subscriptions.add(this.formsService.setarInfosDefaultEmiter.subscribe(() => {
            this.formsService.setaInfosDefault(this.formVidaCoberturas, 'coberturas');
        }));
        this.subscriptions.add(this.formsService.resetaFormularioEmiter.subscribe(() => {
            this.formVidaCoberturas.reset();
        }));
        this.subscriptions.add(this.formVidaCoberturas?.valueChanges.subscribe(() => {
            this.formsService.enviaValidadeFormulario({ formularioNome: 'coberturas', valido: this.formVidaCoberturas.valid });
        }));
        this.subscriptions.add(this.formsService.preencheDraftEmiter.subscribe(draft => {
            this.preencheDraft(draft);
        }));
    }
    preencheDraft(draft) {
        try {
            if (draft && draft.hasOwnProperty('configuracoes') && Object.keys(this.formVidaCoberturas?.controls).length) {
                Object.keys(ConstantFormVida.camposCoberturasPreencherDraft).forEach(campo => {
                    draft.configuracoes[ConstantFormVida.camposCoberturasPreencherDraft[campo]] = FormsService.formatFieldToDraft(campo, this.formVidaCoberturas.controls[campo].value);
                });
                draft.configuracoes.funeral = {
                    tipo: this.formVidaCoberturas.controls.assistFuneral.value,
                    valor: null
                };
                draft.configuracoes.DIT = {
                    qtdDiarias: null,
                    valor: this.formVidaCoberturas.controls.valorDIT.value
                };
                draft.configuracoes.isDoencasGravesGrupo = {
                    qtdDoencas: null,
                    valor: this.formVidaCoberturas.controls.valorDoencasGraves.value
                };
            }
        }
        catch (error) {
            return false;
        }
    }
    alterarValores(select) {
        this.replicarCoberturas.forEach(cob => {
            if (!cob.naoAlterar) {
                this.formVidaCoberturas.controls[cob.cob].setValue(select.value);
            }
        });
        this.formVidaCoberturas.controls.valorDoencasGraves.updateValueAndValidity();
    }
    alterouValor(campo) {
        this.replicarCoberturas.forEach(cob => {
            if (cob.cob === campo) {
                cob.naoAlterar = true;
            }
        });
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormularioVidaCoberturasComponent, deps: [{ token: i1$2.FormBuilder }, { token: FormsService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: FormularioVidaCoberturasComponent, selector: "formulario-vida-coberturas", inputs: { tipo: "tipo", campos: "campos", cobertura: "cobertura" }, ngImport: i0, template: "<form class=\"col-12 form-step\" [formGroup]=\"formVidaCoberturas\">\r\n    <mat-form-field [hidden]=\"!coberturas?.CONFIGURACOES_ISAPPMORTE && recalculo\" [ngClass]=\"!coberturas?.CONFIGURACOES_ISAPPMORTE ? 'col-12 col-md-6 col-lg-6 col-xl-4': 'col-12'\">\r\n      <mat-label>Morte</mat-label>\r\n      <mat-select name=\"assistMorte\" formControlName=\"assistMorte\" (selectionChange)=\"alterarValores($event)\">\r\n        <mat-option *ngFor=\"let v of selects.valoresCoberturasObrigatorias\" [value]=\"v.value\" [attr.custom-reflect-value]=\"v.value\">\r\n          {{ v.viewValue }}\r\n        </mat-option>\r\n      </mat-select>\r\n      <mat-error *ngIf=\"formVidaCoberturas.get('assistMorte').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"!coberturas?.CONFIGURACOES_ISAPPMORTEACIDENTAL && recalculo\" [ngClass]=\"!coberturas?.CONFIGURACOES_ISAPPMORTEACIDENTAL ? 'col-12 col-md-6 col-lg-6 col-xl-4': 'col-12'\">\r\n        <mat-label>Morte acidental</mat-label>\r\n        <mat-select name=\"isAppMorteAcidental\" formControlName=\"isAppMorteAcidental\" (selectionChange)=\"alterouValor('isAppMorteAcidental')\">\r\n          <mat-option *ngFor=\"let v of selects.valoresCoberturasOpcionais\" [value]=\"v.value\" [attr.custom-reflect-value]=\"v.value\">\r\n            {{ v.viewValue }}\r\n          </mat-option>\r\n        </mat-select>\r\n        <mat-error *ngIf=\"formVidaCoberturas.get('isAppMorteAcidental').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"!coberturas?.CONFIGURACOES_ISAPPINVALIDEZ && recalculo\" [ngClass]=\"!coberturas?.CONFIGURACOES_ISAPPINVALIDEZ ? 'col-12 col-md-6 col-lg-6 col-xl-4': 'col-12'\">\r\n        <mat-label>Invalidez permanente (IPA)</mat-label>\r\n        <mat-select name=\"isAppInvalidez\" formControlName=\"isAppInvalidez\" (selectionChange)=\"alterouValor('isAppInvalidez')\">\r\n          <mat-option *ngFor=\"let v of selects.valoresCoberturasOpcionais\" [value]=\"v.value\" [attr.custom-reflect-value]=\"v.value\">\r\n            {{ v.viewValue }}\r\n          </mat-option>\r\n        </mat-select>\r\n        <mat-error *ngIf=\"formVidaCoberturas.get('isAppInvalidez').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"!coberturas?.CONFIGURACOES_FUNERAL && recalculo \" [ngClass]=\"!coberturas?.CONFIGURACOES_FUNERAL ? 'col-12 col-md-6 col-lg-6 col-xl-4': 'col-12'\">\r\n        <mat-label>Assist\u00EAncia funeral</mat-label>\r\n        <mat-select formControlName=\"assistFuneral\">\r\n          <mat-option *ngFor=\"let a of selects.assistFuneral\" [value]=\"a.value\">\r\n            {{ a.viewValue }}\r\n          </mat-option>\r\n        </mat-select>\r\n        <mat-error *ngIf=\"formVidaCoberturas.get('isAppInvalidez').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"!coberturas?.CONFIGURACOES_ISDESPESASMEDICASHOSPITALARES && recalculo\" [ngClass]=\"!coberturas?.CONFIGURACOES_ISDESPESASMEDICASHOSPITALARES ? 'col-12 col-md-6 col-lg-6 col-xl-4': 'col-12'\">\r\n        <mat-label>Di\u00E1ria de Interna\u00E7\u00E3o Hospitalar (DIH)</mat-label>\r\n        <mat-select name=\"isDespesasMedicasHospitalares\" formControlName=\"isDespesasMedicasHospitalares\">\r\n          <mat-option *ngFor=\"let v of selects.valoresDIH\" [value]=\"v.value\">\r\n            {{ v.viewValue }}\r\n          </mat-option>\r\n        </mat-select>\r\n        <mat-error *ngIf=\"formVidaCoberturas.get('isDespesasMedicasHospitalares').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"!coberturas?.CONFIGURACOES_ISINVALIDEZDOENCAS && recalculo\" [ngClass]=\"!coberturas?.CONFIGURACOES_ISINVALIDEZDOENCAS ? 'col-12 col-md-6 col-lg-6 col-xl-4': 'col-12'\">\r\n        <mat-label>Invalidez por doen\u00E7a (IFPD)</mat-label>\r\n        <mat-select name=\"isInvalidezDoenca\" formControlName=\"isInvalidezDoenca\" (selectionChange)=\"alterouValor('isInvalidezDoenca')\">\r\n          <mat-option *ngFor=\"let v of selects.valoresCoberturasOpcionais\" [value]=\"v.value\">\r\n            {{ v.viewValue }}\r\n          </mat-option>\r\n        </mat-select>\r\n        <mat-error *ngIf=\"formVidaCoberturas.get('isInvalidezDoenca').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"recalculo &&  (!coberturas?.CONFIGURACOES_DIT || !coberturas?.CONFIGURACOES_ISVALORDIT)\" [ngClass]=\"!coberturas?.CONFIGURACOES_DIT || !coberturas?.CONFIGURACOES_ISVALORDIT? 'col-12 col-md-6 col-lg-6 col-xl-4 select-field' : 'col-12 select-field' \">\r\n        <mat-label>Di\u00E1ria de Incapacidade Tempor\u00E1ria (DIT)</mat-label>\r\n        <mat-select name=\"valorDIT\" formControlName=\"valorDIT\">\r\n          <mat-option *ngFor=\"let v of selects.valoresDIT\" [value]=\"v.value\">\r\n            {{ v.viewValue }}\r\n          </mat-option>\r\n        </mat-select>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"recalculo &&  (!coberturas?.CONFIGURACOES_ISDOECASGRAVESGRUPO || !coberturas?.CONFIGURACOES_ISVALORDOENCASGRAVES)\" [ngClass]=\"!coberturas?.CONFIGURACOES_ISDOECASGRAVESGRUPO || !coberturas?.CONFIGURACOES_ISVALORDOENCASGRAVES ? 'col-12 col-md-6 col-lg-6 col-xl-4' : 'col-12'\">\r\n        <mat-label>Doen\u00E7as graves</mat-label>\r\n        <mat-select name=\"valorDoencasGraves\" formControlName=\"valorDoencasGraves\">\r\n          <mat-option *ngFor=\"let v of selects.valoresCoberturasOpcionais\" [value]=\"v.value\">\r\n            {{ v.viewValue }}\r\n          </mat-option>\r\n        </mat-select>\r\n        <mat-error *ngIf=\"formVidaCoberturas.get('valorDoencasGraves').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o.</mat-error>\r\n        <mat-error *ngIf=\"formVidaCoberturas.get('valorDoencasGraves').hasError('doencasMaiorQueMorte')\">{{this.formVidaCoberturas.get('valorDoencasGraves').errors.doencasMaiorQueMorte.message}}</mat-error>\r\n    </mat-form-field>\r\n\r\n    <button tabindex=\"-1\" id=\"submitFormCoberturas\" style=\"opacity: 0; position: absolute; z-index: -1000\"></button>\r\n</form>\r\n", styles: [".form-step{padding:0 15px}.form-step .campo-icone{position:absolute;right:0;top:10px;cursor:pointer;color:var(--color-icon)}\n"], dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "component", type: i4.MatFormField, selector: "mat-form-field", inputs: ["hideRequiredMarker", "color", "floatLabel", "appearance", "subscriptSizing", "hintLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i4.MatLabel, selector: "mat-label" }, { kind: "directive", type: i4.MatError, selector: "mat-error, [matError]", inputs: ["id"] }, { kind: "component", type: i6$1.MatOption, selector: "mat-option", inputs: ["value", "id", "disabled"], outputs: ["onSelectionChange"], exportAs: ["matOption"] }, { kind: "component", type: i8.MatSelect, selector: "mat-select", inputs: ["aria-describedby", "panelClass", "disabled", "disableRipple", "tabIndex", "hideSingleSelectionIndicator", "placeholder", "required", "multiple", "disableOptionCentering", "compareWith", "value", "aria-label", "aria-labelledby", "errorStateMatcher", "typeaheadDebounceInterval", "sortComparator", "id", "panelWidth"], outputs: ["openedChange", "opened", "closed", "selectionChange", "valueChange"], exportAs: ["matSelect"] }, { kind: "directive", type: i1$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormularioVidaCoberturasComponent, decorators: [{
            type: Component,
            args: [{ selector: 'formulario-vida-coberturas', template: "<form class=\"col-12 form-step\" [formGroup]=\"formVidaCoberturas\">\r\n    <mat-form-field [hidden]=\"!coberturas?.CONFIGURACOES_ISAPPMORTE && recalculo\" [ngClass]=\"!coberturas?.CONFIGURACOES_ISAPPMORTE ? 'col-12 col-md-6 col-lg-6 col-xl-4': 'col-12'\">\r\n      <mat-label>Morte</mat-label>\r\n      <mat-select name=\"assistMorte\" formControlName=\"assistMorte\" (selectionChange)=\"alterarValores($event)\">\r\n        <mat-option *ngFor=\"let v of selects.valoresCoberturasObrigatorias\" [value]=\"v.value\" [attr.custom-reflect-value]=\"v.value\">\r\n          {{ v.viewValue }}\r\n        </mat-option>\r\n      </mat-select>\r\n      <mat-error *ngIf=\"formVidaCoberturas.get('assistMorte').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"!coberturas?.CONFIGURACOES_ISAPPMORTEACIDENTAL && recalculo\" [ngClass]=\"!coberturas?.CONFIGURACOES_ISAPPMORTEACIDENTAL ? 'col-12 col-md-6 col-lg-6 col-xl-4': 'col-12'\">\r\n        <mat-label>Morte acidental</mat-label>\r\n        <mat-select name=\"isAppMorteAcidental\" formControlName=\"isAppMorteAcidental\" (selectionChange)=\"alterouValor('isAppMorteAcidental')\">\r\n          <mat-option *ngFor=\"let v of selects.valoresCoberturasOpcionais\" [value]=\"v.value\" [attr.custom-reflect-value]=\"v.value\">\r\n            {{ v.viewValue }}\r\n          </mat-option>\r\n        </mat-select>\r\n        <mat-error *ngIf=\"formVidaCoberturas.get('isAppMorteAcidental').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"!coberturas?.CONFIGURACOES_ISAPPINVALIDEZ && recalculo\" [ngClass]=\"!coberturas?.CONFIGURACOES_ISAPPINVALIDEZ ? 'col-12 col-md-6 col-lg-6 col-xl-4': 'col-12'\">\r\n        <mat-label>Invalidez permanente (IPA)</mat-label>\r\n        <mat-select name=\"isAppInvalidez\" formControlName=\"isAppInvalidez\" (selectionChange)=\"alterouValor('isAppInvalidez')\">\r\n          <mat-option *ngFor=\"let v of selects.valoresCoberturasOpcionais\" [value]=\"v.value\" [attr.custom-reflect-value]=\"v.value\">\r\n            {{ v.viewValue }}\r\n          </mat-option>\r\n        </mat-select>\r\n        <mat-error *ngIf=\"formVidaCoberturas.get('isAppInvalidez').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"!coberturas?.CONFIGURACOES_FUNERAL && recalculo \" [ngClass]=\"!coberturas?.CONFIGURACOES_FUNERAL ? 'col-12 col-md-6 col-lg-6 col-xl-4': 'col-12'\">\r\n        <mat-label>Assist\u00EAncia funeral</mat-label>\r\n        <mat-select formControlName=\"assistFuneral\">\r\n          <mat-option *ngFor=\"let a of selects.assistFuneral\" [value]=\"a.value\">\r\n            {{ a.viewValue }}\r\n          </mat-option>\r\n        </mat-select>\r\n        <mat-error *ngIf=\"formVidaCoberturas.get('isAppInvalidez').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"!coberturas?.CONFIGURACOES_ISDESPESASMEDICASHOSPITALARES && recalculo\" [ngClass]=\"!coberturas?.CONFIGURACOES_ISDESPESASMEDICASHOSPITALARES ? 'col-12 col-md-6 col-lg-6 col-xl-4': 'col-12'\">\r\n        <mat-label>Di\u00E1ria de Interna\u00E7\u00E3o Hospitalar (DIH)</mat-label>\r\n        <mat-select name=\"isDespesasMedicasHospitalares\" formControlName=\"isDespesasMedicasHospitalares\">\r\n          <mat-option *ngFor=\"let v of selects.valoresDIH\" [value]=\"v.value\">\r\n            {{ v.viewValue }}\r\n          </mat-option>\r\n        </mat-select>\r\n        <mat-error *ngIf=\"formVidaCoberturas.get('isDespesasMedicasHospitalares').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"!coberturas?.CONFIGURACOES_ISINVALIDEZDOENCAS && recalculo\" [ngClass]=\"!coberturas?.CONFIGURACOES_ISINVALIDEZDOENCAS ? 'col-12 col-md-6 col-lg-6 col-xl-4': 'col-12'\">\r\n        <mat-label>Invalidez por doen\u00E7a (IFPD)</mat-label>\r\n        <mat-select name=\"isInvalidezDoenca\" formControlName=\"isInvalidezDoenca\" (selectionChange)=\"alterouValor('isInvalidezDoenca')\">\r\n          <mat-option *ngFor=\"let v of selects.valoresCoberturasOpcionais\" [value]=\"v.value\">\r\n            {{ v.viewValue }}\r\n          </mat-option>\r\n        </mat-select>\r\n        <mat-error *ngIf=\"formVidaCoberturas.get('isInvalidezDoenca').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"recalculo &&  (!coberturas?.CONFIGURACOES_DIT || !coberturas?.CONFIGURACOES_ISVALORDIT)\" [ngClass]=\"!coberturas?.CONFIGURACOES_DIT || !coberturas?.CONFIGURACOES_ISVALORDIT? 'col-12 col-md-6 col-lg-6 col-xl-4 select-field' : 'col-12 select-field' \">\r\n        <mat-label>Di\u00E1ria de Incapacidade Tempor\u00E1ria (DIT)</mat-label>\r\n        <mat-select name=\"valorDIT\" formControlName=\"valorDIT\">\r\n          <mat-option *ngFor=\"let v of selects.valoresDIT\" [value]=\"v.value\">\r\n            {{ v.viewValue }}\r\n          </mat-option>\r\n        </mat-select>\r\n    </mat-form-field>\r\n\r\n    <mat-form-field [hidden]=\"recalculo &&  (!coberturas?.CONFIGURACOES_ISDOECASGRAVESGRUPO || !coberturas?.CONFIGURACOES_ISVALORDOENCASGRAVES)\" [ngClass]=\"!coberturas?.CONFIGURACOES_ISDOECASGRAVESGRUPO || !coberturas?.CONFIGURACOES_ISVALORDOENCASGRAVES ? 'col-12 col-md-6 col-lg-6 col-xl-4' : 'col-12'\">\r\n        <mat-label>Doen\u00E7as graves</mat-label>\r\n        <mat-select name=\"valorDoencasGraves\" formControlName=\"valorDoencasGraves\">\r\n          <mat-option *ngFor=\"let v of selects.valoresCoberturasOpcionais\" [value]=\"v.value\">\r\n            {{ v.viewValue }}\r\n          </mat-option>\r\n        </mat-select>\r\n        <mat-error *ngIf=\"formVidaCoberturas.get('valorDoencasGraves').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o.</mat-error>\r\n        <mat-error *ngIf=\"formVidaCoberturas.get('valorDoencasGraves').hasError('doencasMaiorQueMorte')\">{{this.formVidaCoberturas.get('valorDoencasGraves').errors.doencasMaiorQueMorte.message}}</mat-error>\r\n    </mat-form-field>\r\n\r\n    <button tabindex=\"-1\" id=\"submitFormCoberturas\" style=\"opacity: 0; position: absolute; z-index: -1000\"></button>\r\n</form>\r\n", styles: [".form-step{padding:0 15px}.form-step .campo-icone{position:absolute;right:0;top:10px;cursor:pointer;color:var(--color-icon)}\n"] }]
        }], ctorParameters: () => [{ type: i1$2.FormBuilder }, { type: FormsService }], propDecorators: { tipo: [{
                type: Input
            }], campos: [{
                type: Input
            }], cobertura: [{
                type: Input
            }] } });

class FormularioVidaVigenciaComponent {
    formBuilder;
    formsService;
    masks = ConstantFormVida.maskValidate;
    subscriptions = new Subscription();
    formVidaVigencia;
    campos;
    set campo(value) {
        this.campos = value;
    }
    constructor(formBuilder, formsService) {
        this.formBuilder = formBuilder;
        this.formsService = formsService;
        this.formVidaVigencia = this.formBuilder.group({
            vigenciaIni: new FormControl(FormsService.geraDataVigencia(), [Validators.required, FormsService.validarData()]),
        });
    }
    ngOnInit() {
        this.inscreverEmiters();
    }
    ngOnDestroy() {
        this.formsService.salvaDraftFinal();
        this.subscriptions.unsubscribe();
    }
    alteraDataVigenciaIni(chamadaManual) {
        if (!this.formsService.verificaDataFormulario(this.formVidaVigencia?.controls.vigenciaIni.value)) {
            let tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            this.formVidaVigencia?.controls.vigenciaIni.setValue(this.formsService.converteDataAmerica(tomorrow));
            if (chamadaManual)
                this.formsService.openSnackbarModal('A data do início de vigência não pode ser retroativa.');
        }
    }
    carregaInfosDraft(draft) {
        if (draft && Object.keys(this.formVidaVigencia.controls).length) {
            this.formVidaVigencia.controls.vigenciaIni.setValue(FormsService.formatField('vigenciaIni', draft?.vigenciaIni));
        }
    }
    inscreverEmiters() {
        this.subscriptions.add(this.formsService.setarInfosDefaultEmiter.subscribe(() => {
            this.formVidaVigencia.controls.vigenciaIni.setValue(FormsService.geraDataVigencia());
        }));
        this.subscriptions.add(this.formsService.resetaFormularioEmiter.subscribe(() => {
            this.formVidaVigencia.reset();
        }));
        this.subscriptions.add(this.formVidaVigencia?.valueChanges.subscribe(() => {
            this.formsService.enviaValidadeFormulario({ formularioNome: 'vigencia', valido: this.formVidaVigencia.valid });
        }));
        this.subscriptions.add(this.formsService.preencheFormularioEmiter.subscribe(draft => {
            this.carregaInfosDraft(draft);
            this.alteraDataVigenciaIni(false);
        }));
        this.subscriptions.add(this.formsService.preencheDraftEmiter.subscribe(draft => {
            this.preencheDraft(draft);
        }));
    }
    preencheDraft(draft) {
        try {
            if (draft && Object.keys(this.formVidaVigencia?.controls).length) {
                draft.vigenciaIni = FormsService.formatFieldToDraft('vigenciaIni', this.formVidaVigencia.controls.vigenciaIni.value);
            }
        }
        catch (error) {
            return false;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormularioVidaVigenciaComponent, deps: [{ token: i1$2.FormBuilder }, { token: FormsService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: FormularioVidaVigenciaComponent, selector: "formulario-vida-vigencia", inputs: { campo: "campo" }, ngImport: i0, template: "<form class=\"col-12 form-step\" [formGroup]=\"formVidaVigencia\">\r\n    <mat-form-field class=\"col-12 col-md-6 col-lg-6 col-xl-3\">\r\n        <mat-label>In\u00EDcio de vig\u00EAncia</mat-label>\r\n        <input matInput name=\"vigenciaIni\" formControlName=\"vigenciaIni\" [dropSpecialCharacters]=\"false\" [mask]=\"masks.DATA\" (change)=\"alteraDataVigenciaIni(true)\"/>\r\n        <mat-error *ngIf=\"formVidaVigencia.get('vigenciaIni').invalid\">Data Inv\u00E1lida.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <button tabindex=\"-1\" id=\"submitFormVigencia\" style=\"opacity: 0; position: absolute; z-index: -1000\"></button>\r\n</form>", styles: [".form-step{padding:0 15px}\n"], dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "component", type: i4.MatFormField, selector: "mat-form-field", inputs: ["hideRequiredMarker", "color", "floatLabel", "appearance", "subscriptSizing", "hintLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i4.MatLabel, selector: "mat-label" }, { kind: "directive", type: i4.MatError, selector: "mat-error, [matError]", inputs: ["id"] }, { kind: "directive", type: i6.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "directive", type: i7.NgxMaskDirective, selector: "input[mask], textarea[mask]", inputs: ["mask", "specialCharacters", "patterns", "prefix", "suffix", "thousandSeparator", "decimalMarker", "dropSpecialCharacters", "hiddenInput", "showMaskTyped", "placeHolderCharacter", "shownMaskExpression", "showTemplate", "clearIfNotMatch", "validation", "separatorLimit", "allowNegativeNumbers", "leadZeroDateTime", "leadZero", "triggerOnMaskChange", "apm", "inputTransformFn", "outputTransformFn", "keepCharacterPositions"], outputs: ["maskFilled"], exportAs: ["mask", "ngxMask"] }, { kind: "directive", type: i1$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormularioVidaVigenciaComponent, decorators: [{
            type: Component,
            args: [{ selector: 'formulario-vida-vigencia', template: "<form class=\"col-12 form-step\" [formGroup]=\"formVidaVigencia\">\r\n    <mat-form-field class=\"col-12 col-md-6 col-lg-6 col-xl-3\">\r\n        <mat-label>In\u00EDcio de vig\u00EAncia</mat-label>\r\n        <input matInput name=\"vigenciaIni\" formControlName=\"vigenciaIni\" [dropSpecialCharacters]=\"false\" [mask]=\"masks.DATA\" (change)=\"alteraDataVigenciaIni(true)\"/>\r\n        <mat-error *ngIf=\"formVidaVigencia.get('vigenciaIni').invalid\">Data Inv\u00E1lida.</mat-error>\r\n    </mat-form-field>\r\n\r\n    <button tabindex=\"-1\" id=\"submitFormVigencia\" style=\"opacity: 0; position: absolute; z-index: -1000\"></button>\r\n</form>", styles: [".form-step{padding:0 15px}\n"] }]
        }], ctorParameters: () => [{ type: i1$2.FormBuilder }, { type: FormsService }], propDecorators: { campo: [{
                type: Input
            }] } });

class LibFormularioVidaComponent {
    api;
    cdr;
    formsService;
    iconsService;
    routerState;
    formPerfil;
    set contentformPerfil(contentformPerfil) {
        if (contentformPerfil)
            this.formPerfil = contentformPerfil;
    }
    draft;
    exibirTitulo;
    ramo;
    matStepRouteEvent = new EventEmitter();
    salvarEvent = new EventEmitter();
    formularioValido = { segurado: false, perfil: false, coberturas: true, vigencia: false };
    isCopiarCotacao = false;
    userInfos;
    seguradorasStatus;
    currentVersion;
    recalculo = false;
    campos = {};
    subscriptions = new Subscription();
    toolTipVoltarHome = 'VOLTAR PARA HOME';
    clienteIndisponivel = false;
    constructor(api, cdr, formsService, iconsService, routerState) {
        this.api = api;
        this.cdr = cdr;
        this.formsService = formsService;
        this.iconsService = iconsService;
        this.routerState = routerState;
        iconsService.registerIcons(ConstantFormVida.icons);
    }
    setRecalculo(campos) {
        this.recalculo = true;
        this.exibirTitulo = false;
        this.campos = campos;
    }
    ngOnInit() {
        this.inscreverEmiters();
        this.formsService.atualizaDraftFinal.subscribe(() => this.copyObjDraft());
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    ngAfterViewChecked() {
        this.cdr.detectChanges();
    }
    clicaBotoesSubmit() {
        ConstantFormVida.botoesSubmit.forEach(botao => { document.getElementById(botao).click(); });
    }
    clearFieldsAfterChangeRoute(currentRoute) {
        this.formsService.resetaFormulario();
        this.formularioValido = { segurado: false, perfil: false, coberturas: true, vigencia: false };
    }
    copyDraftObj() {
        this.formsService.preencheFormulario(this.draft);
    }
    copyObjDraft() {
        this.formsService.preencheDraft(this.draft);
    }
    enviarInformacoesUsuario(vazio) {
        if (this.userInfos) {
            this.formsService.enviaUserInfos(this.userInfos, vazio);
        }
    }
    enviarSeguradorasStatus() {
        if (this.seguradorasStatus) {
            this.formsService.enviaSeguradorasStatus(this.seguradorasStatus);
        }
    }
    enviarCurrentVersion() {
        if (this.currentVersion) {
            this.formsService.enviarCurrentVersion(this.currentVersion);
        }
    }
    inscreverEmiters() {
        this.subscriptions.add(this.formsService.formularioValidoEmiter.subscribe(infos => this.formularioValido[infos?.formularioNome] = infos?.valido));
        this.subscriptions.add(this.formsService.clienteIndisponivelEmiter.subscribe(clienteIndisponivel => this.setClienteIndisponivel(clienteIndisponivel)));
    }
    async initialize(draft, empty, objadd) {
        this.draft = draft;
        this.userInfos = objadd?.userInfos;
        this.seguradorasStatus = objadd?.seguradorasStatus;
        this.currentVersion = objadd?.currentVersion;
        if (!empty)
            this.formsService.preencheFormulario(draft);
        else
            this.formsService.setarInfosDefault();
        this.enviarInformacoesUsuario(empty);
        this.enviarSeguradorasStatus();
        this.preencheProfissoesSelecionadas();
    }
    matStepRoute(action) {
        if (action == 'next') {
            this.isCopiarCotacao = false;
            this.clicaBotoesSubmit();
            if (this.clienteIndisponivel) {
                this.formsService.openSnackbarModal('Este cálculo pertence a outro corretor.');
            }
            else {
                if (this.validarForm()) {
                    this.copyObjDraft();
                    this.matStepRouteEvent.emit(action);
                }
                else {
                    this.formsService.openSnackbarModal('Preencha todas informações obrigatórias antes de prosseguir.');
                }
            }
        }
        else {
            if ((this.draft?.status == undefined || this.draft?.status == 1))
                this.routerState.navigateByUrl(this.api.getUrlHome());
            else
                this.matStepRouteEvent.emit(action);
        }
    }
    recalcular() {
        return new Promise((resolve) => {
            this.isCopiarCotacao = false;
            this.clicaBotoesSubmit();
            if (this.validarForm()) {
                this.copyObjDraft();
                resolve();
            }
        });
    }
    salvar() {
        this.isCopiarCotacao = false;
        this.copyObjDraft();
        this.salvarEvent.emit({});
    }
    setDraft(draft) {
        this.draft = draft;
        this.initialize(draft, false);
    }
    setClienteIndisponivel(clienteIndisponivel) {
        this.clienteIndisponivel = clienteIndisponivel;
    }
    setToolTipHome(tooltip) {
        this.toolTipVoltarHome = tooltip;
    }
    preencheProfissoesSelecionadas() {
        if (this.currentVersion && Object.keys(this.formPerfil?.profissoesSelecionadas).length == 0) {
            this.formPerfil.preencheProfissoesSelecionadas(this.currentVersion?.calculos);
        }
        else if (this.draft && this.draft?.buscaPorSeguradora && Object.keys(this.draft?.buscaPorSeguradora?.profissao).length > 0) {
            this.formPerfil.profissoesSelecionadas = this.draft.buscaPorSeguradora.profissao;
        }
    }
    getValoresAjusteSeguradora() {
        return { profissao: this.formPerfil.profissoesSelecionadas };
    }
    validarForm() {
        let valido = true;
        Object.keys(this.formularioValido).forEach(formulario => { valido = valido && this.formularioValido[formulario]; });
        valido = Object.keys(this.formPerfil.profissoesSelecionadas).length > 0 ? valido : false;
        return valido;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LibFormularioVidaComponent, deps: [{ token: 'api' }, { token: i0.ChangeDetectorRef }, { token: FormsService }, { token: IconsService }, { token: i3$1.Router }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: LibFormularioVidaComponent, selector: "lib-formulario-vida", inputs: { draft: "draft", exibirTitulo: "exibirTitulo", ramo: "ramo" }, outputs: { matStepRouteEvent: "matStepRouteEvent", salvarEvent: "salvarEvent" }, viewQueries: [{ propertyName: "contentformPerfil", first: true, predicate: ["formPerfil"], descendants: true }], ngImport: i0, template: "<div class=\"container-form\">\r\n  <h1 class=\"title-form\" *ngIf=\"exibirTitulo\">Formul\u00E1rio Vida</h1>\r\n\r\n  <h2 class=\"subtitle-form\" [ngClass]=\"exibirTitulo ? 'tem-titulo' : 'sem-titulo'\" *ngIf=\"!recalculo\">Segurado</h2>\r\n  <formulario-vida-segurado [segurados]=\"campos\"></formulario-vida-segurado>\r\n\r\n  <h2 class=\"subtitle-form\" *ngIf=\"!recalculo\">Perfil</h2>\r\n  <formulario-vida-perfil [perfil]=\"campos\" #formPerfil></formulario-vida-perfil>\r\n\r\n  <h2 class=\"subtitle-form\" *ngIf=\"!recalculo\">Coberturas</h2>\r\n  <formulario-vida-coberturas [cobertura]=\"campos\"></formulario-vida-coberturas>\r\n\r\n  <h2 class=\"subtitle-form\" *ngIf=\"!recalculo\">Vig\u00EAncia</h2>\r\n  <formulario-vida-vigencia [hidden]=\"recalculo && !campos?.VIGENCIAINI\"></formulario-vida-vigencia>\r\n\r\n\r\n  <div class=\"container-buttons-form\" *ngIf=\"!recalculo\">\r\n    <button name=\"btn-voltar\" mat-stroked-button class=\"btn-voltar\" [matTooltipPosition]=\"'left'\"\r\n      (click)=\"matStepRoute('previous')\"\r\n      [matTooltip]=\"(draft?.status == undefined || draft?.status == 1) ? toolTipVoltarHome : 'VOLTAR PARA RESULTADOS'\">\r\n      <span class=\"text-btn\">VOLTAR</span>\r\n    </button>\r\n    <button name=\"btn-salvar\" mat-stroked-button class=\"btn-salvar\" matTooltip=\"SALVAR C\u00C1LCULO\"\r\n      [matTooltipPosition]=\"'right'\" (click)=\"salvar()\">\r\n      <span class=\"text-btn\">SALVAR</span>\r\n    </button>\r\n    <button name=\"btn-proximo\" mat-flat-button class=\"btn-proximo\"\r\n      matTooltip=\"SELECIONAR SEGURADORAS\" [matTooltipPosition]=\"'right'\" (click)=\"matStepRoute('next')\">\r\n      <span class=\"text-btn\">PR\u00D3XIMO</span>\r\n    </button>\r\n  </div>\r\n</div>", styles: [".container-form{background-color:transparent}.container-form .title-form{text-align:center;font-size:22px;text-transform:uppercase;letter-spacing:2px;font-weight:400;color:var(--color-dark);margin-top:.9em;width:100%}.container-form .subtitle-form{padding:15px;margin-bottom:0;font-size:18px;color:var(--color-tertiary-first);text-transform:uppercase;margin-left:7px!important;line-height:22px;font-weight:500}.container-form .sem-titulo{height:64px;align-items:center}@media (max-width: 426px){.container-form .title-form{font-size:16px;font-weight:500;margin:0}.container-form .subtitle-form{font-size:14px;font-weight:500}}.container-buttons-form{display:flex;align-items:baseline;justify-content:center;background-color:transparent;padding-bottom:10px;gap:24px;margin:0 10px}@media (max-width: 480px){.container-buttons-form{gap:8px}}.container-buttons-form button{height:40px;padding:10px;border-radius:3px}.container-buttons-form button .text-btn{font-size:14px;line-height:normal}.container-buttons-form .btn-voltar{width:120px;background-color:transparent;border:1px solid #60616A}.container-buttons-form .btn-voltar .text-btn{color:#60616a;font-weight:400;letter-spacing:normal}.container-buttons-form .btn-salvar{width:120px;background-color:transparent;border:1px solid var(--color-tertiary-first)}.container-buttons-form .btn-salvar .text-btn{color:var(--color-tertiary-first);font-weight:400;letter-spacing:normal}.container-buttons-form .btn-proximo{width:164px;background-color:var(--color-tertiary-first)}.container-buttons-form .btn-proximo .text-btn{color:#fefefe;font-weight:500;letter-spacing:.42px}.container-buttons-form button:focus{outline:none}::ng-deep .container-buttons-form button .mat-mdc-button-touch-target{height:40px}::ng-deep .container-form .mat-select-value-text{font-weight:400;color:var(--color-dark)}::ng-deep .container-form .mat-select-value{color:#0000008a}::ng-deep .container-form .mat-mdc-form-field{font-weight:500;letter-spacing:normal;color:#0000008a;padding:0 7px;height:38px;display:inline-block;position:relative;text-align:left}::ng-deep .container-form .container-form-auto .mdc-text-field--filled:not(.mdc-text-field--disabled){height:38px}::ng-deep .container-form .mat-mdc-form-field-hint-wrapper,::ng-deep .container-form .mat-mdc-form-field-error-wrapper{padding:0;top:-2px}::ng-deep .container-form .mat-mdc-text-field-wrapper .mat-mdc-form-field-infix .mdc-floating-label--float-above{top:16px!important}::ng-deep .container-form .mat-mdc-text-field-wrapper .mat-mdc-form-field-infix .mat-mdc-floating-label{top:23px;letter-spacing:normal;line-height:15.75px;color:var(--color-dark)}::ng-deep .container-form .mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__input{color:var(--color-dark);font-size:14px;font-weight:400;height:46px;margin:0}::ng-deep .container-form .chip-form-field .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-infix{display:flex}::ng-deep .container-form .mdc-text-field .mdc-text-field__input{font-size:14px;font-weight:400;height:46px}::ng-deep .container-form .mdc-text-field--disabled .mdc-line-ripple{display:none}::ng-deep .container-form .mat-form-field-disabled .mat-mdc-form-field-hint-wrapper{background-image:linear-gradient(90deg,rgba(0,0,0,.42) 0,rgba(0,0,0,.42) 33%,transparent 0);background-size:4px 100%;background-repeat:repeat-x;height:1px}::ng-deep .container-form .mdc-text-field--focused:not(.mdc-text-field--disabled) .mdc-floating-label{color:var(--color-primary)}::ng-deep .container-form .mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-floating-label{color:var(--mdc-theme-error, #f44336)!important}::ng-deep .container-form .mat-mdc-form-field.mat-focused.mat-warn .mat-mdc-select-arrow,::ng-deep .container-form .mat-mdc-form-field .mat-mdc-select.mat-mdc-select-invalid .mat-mdc-select-arrow{color:var(--mdc-theme-error, #f44336)!important}::ng-deep .container-form .mat-mdc-form-field-error{font-size:10.5px;line-height:10.5px;letter-spacing:normal}::ng-deep .container-form .mat-form-field-appearance-fill .mat-mdc-select-arrow-wrapper{transform:translateY(0)}::ng-deep .container-form .mat-mdc-select-trigger{font-size:14px}::ng-deep .container-form .mdc-text-field--filled{background-color:transparent!important;padding:0;height:38px}::ng-deep .container-form .mat-mdc-form-field-focus-overlay{background-color:transparent}::ng-deep .container-form .mat-mdc-text-field-wrapper:not(.mdc-text-field--outlined) .mat-mdc-form-field-infix{padding-top:0;padding-bottom:0}::ng-deep .container-form .mat-mdc-form-field-infix{min-height:38px}::ng-deep .container-form .mat-mdc-select-trigger{height:48px}::ng-deep .container-form .mat-mdc-form-field-subscript-wrapper{box-sizing:border-box;width:100%;position:relative;height:17.5px}::ng-deep .container-form .mdc-floating-label{font-size:14px;color:var(--color-dark)}::ng-deep .container-form .mdc-text-field .mdc-text-field__input{caret-color:var(--color-primary)}::ng-deep .container-form .mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-line-ripple:before{border-bottom-color:var(--mdc-theme-error, #f44336)}::ng-deep .container-form .mdc-text-field--invalid:not(.mdc-text-field--disabled):hover .mdc-line-ripple:before{border-bottom-color:var(--mdc-theme-error, #f44336)}::ng-deep .container-form .mdc-text-field--filled:not(.mdc-text-field--invalid) .mdc-line-ripple:after{border-bottom-color:var(--color-primary)}::ng-deep .container-form .mdc-text-field--filled:not(.mdc-text-field--disabled):not(.mdc-text-field--invalid):hover .mdc-line-ripple:before{border-bottom-color:#0000006b}::ng-deep .container-form .mat-mdc-form-field.mat-focused.mat-primary .mat-mdc-select-arrow{color:var(--color-primary)}::ng-deep .container-form .mat-mdc-progress-spinner{--mdc-circular-progress-active-indicator-color: var(--color-primary)}::ng-deep .container-form .mdc-text-field--invalid .mdc-text-field__input{caret-color:var(--mdc-theme-error, #f44336)}::ng-deep .container-form .mdc-text-field--disabled.mdc-text-field--filled{background-color:transparent}::ng-deep .container-form .mat-mdc-checkbox.mat-accent{--mdc-checkbox-selected-checkmark-color: #fff;--mdc-checkbox-selected-focus-icon-color: var(--color-primary);--mdc-checkbox-selected-hover-icon-color: var(--color-primary);--mdc-checkbox-selected-icon-color: var(--color-primary);--mdc-checkbox-selected-pressed-icon-color: var(--color-primary);--mdc-checkbox-unselected-focus-icon-color: rgba(0, 0, 0, .54);--mdc-checkbox-unselected-hover-icon-color: rgba(0, 0, 0, .54);--mdc-checkbox-disabled-selected-icon-color: rgba(0, 0, 0, .54);--mdc-checkbox-disabled-unselected-icon-color: rgba(0, 0, 0, .54);--mdc-checkbox-unselected-icon-color: rgba(0, 0, 0, .54);--mdc-checkbox-unselected-pressed-icon-color: rgba(0, 0, 0, .54)}::ng-deep .container-form .mat-mdc-checkbox.mat-accent .mdc-checkbox__ripple{background:var(--color-secundary)}::ng-deep .mat-primary .mat-mdc-option.mdc-list-item--selected:not(.mdc-list-item--disabled) .mdc-list-item__primary-text{color:var(--color-primary)}::ng-deep .mat-mdc-option .mdc-list-item__primary-text{font-size:14px!important}::ng-deep .mdc-tooltip__surface{font-size:10px!important}::ng-deep .mat-mdc-option .mat-pseudo-checkbox{display:none!important}::ng-deep .mat-mdc-option-multiple .mat-pseudo-checkbox{display:block!important}::ng-deep .opt-group-com-logo .mat-mdc-optgroup-label .mdc-list-item__primary-text{display:flex;flex-direction:row-reverse;align-items:center;gap:8px;font-size:13px;font-style:normal;font-weight:400;line-height:normal;letter-spacing:.5px}::ng-deep .opt-group-com-logo .mat-mdc-optgroup-label .mdc-list-item__primary-text .logo-seguradora{width:25px;height:25px}::ng-deep .opt-group-com-logo .mat-mdc-option{padding:0!important;min-height:38px}::ng-deep .opt-group-com-logo .mat-mdc-option .mdc-list-item__primary-text .container-selecao{display:flex;align-items:center;gap:14px;padding:8px 0 8px 22px;width:500px;min-height:38px}::ng-deep .opt-group-com-logo .mat-mdc-option .mdc-list-item__primary-text .container-selecao input[type=radio]{accent-color:var(--color-primary)}::ng-deep .opt-group-com-logo .mat-mdc-option .mdc-list-item__primary-text .container-selecao .sem-opcao{color:#7e8088}::ng-deep .opt-group-com-logo .mat-mdc-option .mdc-list-item__primary-text .container-selecao span:not(.sem-opcao):not(.mostrar-todas){color:#60616a}::ng-deep .opt-group-com-logo .mat-mdc-option .mdc-list-item__primary-text .container-selecao .mostrar-todas{color:var(--color-primary);font-size:12px;font-style:normal;font-weight:400;line-height:normal;cursor:pointer}::ng-deep .opt-group-com-logo .mat-mdc-option .mdc-list-item__primary-text .container-selecao span:not(.mostrar-todas){font-size:13px!important;font-style:normal;font-weight:400;line-height:18px}::ng-deep .opt-group-com-logo .opt-btn-ver-todos{pointer-events:initial!important}::ng-deep .opt-group-com-logo .opt-btn-ver-todos .mdc-list-item__primary-text{opacity:1!important}::ng-deep .opt-group-com-logo .mat-mdc-option.mdc-list-item--disabled{opacity:1}::ng-deep .opt-group-com-logo .mat-mdc-option.mdc-list-item--disabled .mdc-list-item__primary-text{color:#7e8088}::ng-deep .opt-group-com-logo:not(:last-child) .mat-mdc-option:last-child{border-bottom:.854px solid #E5E6E7}::ng-deep .seguradora-inativa .mat-mdc-optgroup-label .mdc-list-item__primary-text{color:#b5b5b5}::ng-deep .seguradora-inativa .mat-mdc-optgroup-label .mdc-list-item__primary-text .logo-seguradora{opacity:.5}::ng-deep .seguradora-ativa .mat-mdc-optgroup-label .mdc-list-item__primary-text{color:#7e8088}::ng-deep .mat-mdc-standard-chip{--mdc-chip-elevated-container-color: white;--mdc-chip-label-text-color: #60616A;--mdc-chip-disabled-label-text-color: #60616A;--mdc-chip-with-icon-icon-color: #60616A;--mdc-chip-with-icon-disabled-icon-color: #60616A;--mdc-chip-with-trailing-icon-disabled-trailing-icon-color: #60616A;--mdc-chip-with-trailing-icon-trailing-icon-color: #60616A;--mdc-chip-with-icon-selected-icon-color: #60616A}::ng-deep .mdc-evolution-chip-set{padding:0 7px}::ng-deep .mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled){border-radius:5px;border:1px solid #D0D2D3;height:35px}::ng-deep .mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) .mat-mdc-chip-action{cursor:default}::ng-deep .mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) .mat-mdc-chip-remove{cursor:pointer}::ng-deep .mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) .mdc-evolution-chip__text-label{display:flex;align-items:center}::ng-deep .mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) .mdc-evolution-chip__text-label span{color:#7e8088;font-size:12px;font-style:normal;font-weight:400;line-height:normal}::ng-deep .mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) .mdc-evolution-chip__text-label .logo-seguradora{width:25px;height:25px;margin-right:4px}::ng-deep .autocomplete-busca-profissao{max-height:340px!important}\n"], dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: FormularioVidaSeguradoComponent, selector: "formulario-vida-segurado", inputs: ["segurados"] }, { kind: "component", type: FormularioVidaPerfilComponent, selector: "formulario-vida-perfil", inputs: ["perfil"] }, { kind: "component", type: FormularioVidaCoberturasComponent, selector: "formulario-vida-coberturas", inputs: ["tipo", "campos", "cobertura"] }, { kind: "component", type: FormularioVidaVigenciaComponent, selector: "formulario-vida-vigencia", inputs: ["campo"] }, { kind: "component", type: i9$1.MatButton, selector: "    button[mat-button], button[mat-raised-button], button[mat-flat-button],    button[mat-stroked-button]  ", exportAs: ["matButton"] }, { kind: "directive", type: i11.MatTooltip, selector: "[matTooltip]", inputs: ["matTooltipPosition", "matTooltipPositionAtOrigin", "matTooltipDisabled", "matTooltipShowDelay", "matTooltipHideDelay", "matTooltipTouchGestures", "matTooltip", "matTooltipClass"], exportAs: ["matTooltip"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LibFormularioVidaComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-formulario-vida', template: "<div class=\"container-form\">\r\n  <h1 class=\"title-form\" *ngIf=\"exibirTitulo\">Formul\u00E1rio Vida</h1>\r\n\r\n  <h2 class=\"subtitle-form\" [ngClass]=\"exibirTitulo ? 'tem-titulo' : 'sem-titulo'\" *ngIf=\"!recalculo\">Segurado</h2>\r\n  <formulario-vida-segurado [segurados]=\"campos\"></formulario-vida-segurado>\r\n\r\n  <h2 class=\"subtitle-form\" *ngIf=\"!recalculo\">Perfil</h2>\r\n  <formulario-vida-perfil [perfil]=\"campos\" #formPerfil></formulario-vida-perfil>\r\n\r\n  <h2 class=\"subtitle-form\" *ngIf=\"!recalculo\">Coberturas</h2>\r\n  <formulario-vida-coberturas [cobertura]=\"campos\"></formulario-vida-coberturas>\r\n\r\n  <h2 class=\"subtitle-form\" *ngIf=\"!recalculo\">Vig\u00EAncia</h2>\r\n  <formulario-vida-vigencia [hidden]=\"recalculo && !campos?.VIGENCIAINI\"></formulario-vida-vigencia>\r\n\r\n\r\n  <div class=\"container-buttons-form\" *ngIf=\"!recalculo\">\r\n    <button name=\"btn-voltar\" mat-stroked-button class=\"btn-voltar\" [matTooltipPosition]=\"'left'\"\r\n      (click)=\"matStepRoute('previous')\"\r\n      [matTooltip]=\"(draft?.status == undefined || draft?.status == 1) ? toolTipVoltarHome : 'VOLTAR PARA RESULTADOS'\">\r\n      <span class=\"text-btn\">VOLTAR</span>\r\n    </button>\r\n    <button name=\"btn-salvar\" mat-stroked-button class=\"btn-salvar\" matTooltip=\"SALVAR C\u00C1LCULO\"\r\n      [matTooltipPosition]=\"'right'\" (click)=\"salvar()\">\r\n      <span class=\"text-btn\">SALVAR</span>\r\n    </button>\r\n    <button name=\"btn-proximo\" mat-flat-button class=\"btn-proximo\"\r\n      matTooltip=\"SELECIONAR SEGURADORAS\" [matTooltipPosition]=\"'right'\" (click)=\"matStepRoute('next')\">\r\n      <span class=\"text-btn\">PR\u00D3XIMO</span>\r\n    </button>\r\n  </div>\r\n</div>", styles: [".container-form{background-color:transparent}.container-form .title-form{text-align:center;font-size:22px;text-transform:uppercase;letter-spacing:2px;font-weight:400;color:var(--color-dark);margin-top:.9em;width:100%}.container-form .subtitle-form{padding:15px;margin-bottom:0;font-size:18px;color:var(--color-tertiary-first);text-transform:uppercase;margin-left:7px!important;line-height:22px;font-weight:500}.container-form .sem-titulo{height:64px;align-items:center}@media (max-width: 426px){.container-form .title-form{font-size:16px;font-weight:500;margin:0}.container-form .subtitle-form{font-size:14px;font-weight:500}}.container-buttons-form{display:flex;align-items:baseline;justify-content:center;background-color:transparent;padding-bottom:10px;gap:24px;margin:0 10px}@media (max-width: 480px){.container-buttons-form{gap:8px}}.container-buttons-form button{height:40px;padding:10px;border-radius:3px}.container-buttons-form button .text-btn{font-size:14px;line-height:normal}.container-buttons-form .btn-voltar{width:120px;background-color:transparent;border:1px solid #60616A}.container-buttons-form .btn-voltar .text-btn{color:#60616a;font-weight:400;letter-spacing:normal}.container-buttons-form .btn-salvar{width:120px;background-color:transparent;border:1px solid var(--color-tertiary-first)}.container-buttons-form .btn-salvar .text-btn{color:var(--color-tertiary-first);font-weight:400;letter-spacing:normal}.container-buttons-form .btn-proximo{width:164px;background-color:var(--color-tertiary-first)}.container-buttons-form .btn-proximo .text-btn{color:#fefefe;font-weight:500;letter-spacing:.42px}.container-buttons-form button:focus{outline:none}::ng-deep .container-buttons-form button .mat-mdc-button-touch-target{height:40px}::ng-deep .container-form .mat-select-value-text{font-weight:400;color:var(--color-dark)}::ng-deep .container-form .mat-select-value{color:#0000008a}::ng-deep .container-form .mat-mdc-form-field{font-weight:500;letter-spacing:normal;color:#0000008a;padding:0 7px;height:38px;display:inline-block;position:relative;text-align:left}::ng-deep .container-form .container-form-auto .mdc-text-field--filled:not(.mdc-text-field--disabled){height:38px}::ng-deep .container-form .mat-mdc-form-field-hint-wrapper,::ng-deep .container-form .mat-mdc-form-field-error-wrapper{padding:0;top:-2px}::ng-deep .container-form .mat-mdc-text-field-wrapper .mat-mdc-form-field-infix .mdc-floating-label--float-above{top:16px!important}::ng-deep .container-form .mat-mdc-text-field-wrapper .mat-mdc-form-field-infix .mat-mdc-floating-label{top:23px;letter-spacing:normal;line-height:15.75px;color:var(--color-dark)}::ng-deep .container-form .mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__input{color:var(--color-dark);font-size:14px;font-weight:400;height:46px;margin:0}::ng-deep .container-form .chip-form-field .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-infix{display:flex}::ng-deep .container-form .mdc-text-field .mdc-text-field__input{font-size:14px;font-weight:400;height:46px}::ng-deep .container-form .mdc-text-field--disabled .mdc-line-ripple{display:none}::ng-deep .container-form .mat-form-field-disabled .mat-mdc-form-field-hint-wrapper{background-image:linear-gradient(90deg,rgba(0,0,0,.42) 0,rgba(0,0,0,.42) 33%,transparent 0);background-size:4px 100%;background-repeat:repeat-x;height:1px}::ng-deep .container-form .mdc-text-field--focused:not(.mdc-text-field--disabled) .mdc-floating-label{color:var(--color-primary)}::ng-deep .container-form .mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-floating-label{color:var(--mdc-theme-error, #f44336)!important}::ng-deep .container-form .mat-mdc-form-field.mat-focused.mat-warn .mat-mdc-select-arrow,::ng-deep .container-form .mat-mdc-form-field .mat-mdc-select.mat-mdc-select-invalid .mat-mdc-select-arrow{color:var(--mdc-theme-error, #f44336)!important}::ng-deep .container-form .mat-mdc-form-field-error{font-size:10.5px;line-height:10.5px;letter-spacing:normal}::ng-deep .container-form .mat-form-field-appearance-fill .mat-mdc-select-arrow-wrapper{transform:translateY(0)}::ng-deep .container-form .mat-mdc-select-trigger{font-size:14px}::ng-deep .container-form .mdc-text-field--filled{background-color:transparent!important;padding:0;height:38px}::ng-deep .container-form .mat-mdc-form-field-focus-overlay{background-color:transparent}::ng-deep .container-form .mat-mdc-text-field-wrapper:not(.mdc-text-field--outlined) .mat-mdc-form-field-infix{padding-top:0;padding-bottom:0}::ng-deep .container-form .mat-mdc-form-field-infix{min-height:38px}::ng-deep .container-form .mat-mdc-select-trigger{height:48px}::ng-deep .container-form .mat-mdc-form-field-subscript-wrapper{box-sizing:border-box;width:100%;position:relative;height:17.5px}::ng-deep .container-form .mdc-floating-label{font-size:14px;color:var(--color-dark)}::ng-deep .container-form .mdc-text-field .mdc-text-field__input{caret-color:var(--color-primary)}::ng-deep .container-form .mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-line-ripple:before{border-bottom-color:var(--mdc-theme-error, #f44336)}::ng-deep .container-form .mdc-text-field--invalid:not(.mdc-text-field--disabled):hover .mdc-line-ripple:before{border-bottom-color:var(--mdc-theme-error, #f44336)}::ng-deep .container-form .mdc-text-field--filled:not(.mdc-text-field--invalid) .mdc-line-ripple:after{border-bottom-color:var(--color-primary)}::ng-deep .container-form .mdc-text-field--filled:not(.mdc-text-field--disabled):not(.mdc-text-field--invalid):hover .mdc-line-ripple:before{border-bottom-color:#0000006b}::ng-deep .container-form .mat-mdc-form-field.mat-focused.mat-primary .mat-mdc-select-arrow{color:var(--color-primary)}::ng-deep .container-form .mat-mdc-progress-spinner{--mdc-circular-progress-active-indicator-color: var(--color-primary)}::ng-deep .container-form .mdc-text-field--invalid .mdc-text-field__input{caret-color:var(--mdc-theme-error, #f44336)}::ng-deep .container-form .mdc-text-field--disabled.mdc-text-field--filled{background-color:transparent}::ng-deep .container-form .mat-mdc-checkbox.mat-accent{--mdc-checkbox-selected-checkmark-color: #fff;--mdc-checkbox-selected-focus-icon-color: var(--color-primary);--mdc-checkbox-selected-hover-icon-color: var(--color-primary);--mdc-checkbox-selected-icon-color: var(--color-primary);--mdc-checkbox-selected-pressed-icon-color: var(--color-primary);--mdc-checkbox-unselected-focus-icon-color: rgba(0, 0, 0, .54);--mdc-checkbox-unselected-hover-icon-color: rgba(0, 0, 0, .54);--mdc-checkbox-disabled-selected-icon-color: rgba(0, 0, 0, .54);--mdc-checkbox-disabled-unselected-icon-color: rgba(0, 0, 0, .54);--mdc-checkbox-unselected-icon-color: rgba(0, 0, 0, .54);--mdc-checkbox-unselected-pressed-icon-color: rgba(0, 0, 0, .54)}::ng-deep .container-form .mat-mdc-checkbox.mat-accent .mdc-checkbox__ripple{background:var(--color-secundary)}::ng-deep .mat-primary .mat-mdc-option.mdc-list-item--selected:not(.mdc-list-item--disabled) .mdc-list-item__primary-text{color:var(--color-primary)}::ng-deep .mat-mdc-option .mdc-list-item__primary-text{font-size:14px!important}::ng-deep .mdc-tooltip__surface{font-size:10px!important}::ng-deep .mat-mdc-option .mat-pseudo-checkbox{display:none!important}::ng-deep .mat-mdc-option-multiple .mat-pseudo-checkbox{display:block!important}::ng-deep .opt-group-com-logo .mat-mdc-optgroup-label .mdc-list-item__primary-text{display:flex;flex-direction:row-reverse;align-items:center;gap:8px;font-size:13px;font-style:normal;font-weight:400;line-height:normal;letter-spacing:.5px}::ng-deep .opt-group-com-logo .mat-mdc-optgroup-label .mdc-list-item__primary-text .logo-seguradora{width:25px;height:25px}::ng-deep .opt-group-com-logo .mat-mdc-option{padding:0!important;min-height:38px}::ng-deep .opt-group-com-logo .mat-mdc-option .mdc-list-item__primary-text .container-selecao{display:flex;align-items:center;gap:14px;padding:8px 0 8px 22px;width:500px;min-height:38px}::ng-deep .opt-group-com-logo .mat-mdc-option .mdc-list-item__primary-text .container-selecao input[type=radio]{accent-color:var(--color-primary)}::ng-deep .opt-group-com-logo .mat-mdc-option .mdc-list-item__primary-text .container-selecao .sem-opcao{color:#7e8088}::ng-deep .opt-group-com-logo .mat-mdc-option .mdc-list-item__primary-text .container-selecao span:not(.sem-opcao):not(.mostrar-todas){color:#60616a}::ng-deep .opt-group-com-logo .mat-mdc-option .mdc-list-item__primary-text .container-selecao .mostrar-todas{color:var(--color-primary);font-size:12px;font-style:normal;font-weight:400;line-height:normal;cursor:pointer}::ng-deep .opt-group-com-logo .mat-mdc-option .mdc-list-item__primary-text .container-selecao span:not(.mostrar-todas){font-size:13px!important;font-style:normal;font-weight:400;line-height:18px}::ng-deep .opt-group-com-logo .opt-btn-ver-todos{pointer-events:initial!important}::ng-deep .opt-group-com-logo .opt-btn-ver-todos .mdc-list-item__primary-text{opacity:1!important}::ng-deep .opt-group-com-logo .mat-mdc-option.mdc-list-item--disabled{opacity:1}::ng-deep .opt-group-com-logo .mat-mdc-option.mdc-list-item--disabled .mdc-list-item__primary-text{color:#7e8088}::ng-deep .opt-group-com-logo:not(:last-child) .mat-mdc-option:last-child{border-bottom:.854px solid #E5E6E7}::ng-deep .seguradora-inativa .mat-mdc-optgroup-label .mdc-list-item__primary-text{color:#b5b5b5}::ng-deep .seguradora-inativa .mat-mdc-optgroup-label .mdc-list-item__primary-text .logo-seguradora{opacity:.5}::ng-deep .seguradora-ativa .mat-mdc-optgroup-label .mdc-list-item__primary-text{color:#7e8088}::ng-deep .mat-mdc-standard-chip{--mdc-chip-elevated-container-color: white;--mdc-chip-label-text-color: #60616A;--mdc-chip-disabled-label-text-color: #60616A;--mdc-chip-with-icon-icon-color: #60616A;--mdc-chip-with-icon-disabled-icon-color: #60616A;--mdc-chip-with-trailing-icon-disabled-trailing-icon-color: #60616A;--mdc-chip-with-trailing-icon-trailing-icon-color: #60616A;--mdc-chip-with-icon-selected-icon-color: #60616A}::ng-deep .mdc-evolution-chip-set{padding:0 7px}::ng-deep .mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled){border-radius:5px;border:1px solid #D0D2D3;height:35px}::ng-deep .mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) .mat-mdc-chip-action{cursor:default}::ng-deep .mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) .mat-mdc-chip-remove{cursor:pointer}::ng-deep .mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) .mdc-evolution-chip__text-label{display:flex;align-items:center}::ng-deep .mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) .mdc-evolution-chip__text-label span{color:#7e8088;font-size:12px;font-style:normal;font-weight:400;line-height:normal}::ng-deep .mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) .mdc-evolution-chip__text-label .logo-seguradora{width:25px;height:25px;margin-right:4px}::ng-deep .autocomplete-busca-profissao{max-height:340px!important}\n"] }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: ['api']
                }] }, { type: i0.ChangeDetectorRef }, { type: FormsService }, { type: IconsService }, { type: i3$1.Router }], propDecorators: { contentformPerfil: [{
                type: ViewChild,
                args: ['formPerfil']
            }], draft: [{
                type: Input
            }], exibirTitulo: [{
                type: Input
            }], ramo: [{
                type: Input
            }], matStepRouteEvent: [{
                type: Output
            }], salvarEvent: [{
                type: Output
            }] } });

class RemoveAriaOwnsDirective {
    el;
    constructor(el) {
        this.el = el;
    }
    ngAfterViewInit() {
        this.el.nativeElement.parentElement.removeAttribute('aria-owns');
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RemoveAriaOwnsDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: RemoveAriaOwnsDirective, selector: "mat-label", ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RemoveAriaOwnsDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'mat-label'
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }] });

class FormularioVidaSeguradoModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormularioVidaSeguradoModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: FormularioVidaSeguradoModule, declarations: [FormularioVidaSeguradoComponent], imports: [CommonModule,
            FormsModule,
            MatFormFieldModule,
            MatIconModule,
            MatInputModule,
            NgxMaskDirective,
            MatSelectModule,
            NgxMaskPipe,
            ReactiveFormsModule,
            MatProgressSpinnerModule,
            MatTooltipModule], exports: [FormularioVidaSeguradoComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormularioVidaSeguradoModule, providers: [
            provideNgxMask()
        ], imports: [CommonModule,
            FormsModule,
            MatFormFieldModule,
            MatIconModule,
            MatInputModule,
            MatSelectModule,
            ReactiveFormsModule,
            MatProgressSpinnerModule,
            MatTooltipModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormularioVidaSeguradoModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FormularioVidaSeguradoComponent],
                    imports: [
                        CommonModule,
                        FormsModule,
                        MatFormFieldModule,
                        MatIconModule,
                        MatInputModule,
                        NgxMaskDirective,
                        MatSelectModule,
                        NgxMaskPipe,
                        ReactiveFormsModule,
                        MatProgressSpinnerModule,
                        MatTooltipModule
                    ],
                    exports: [FormularioVidaSeguradoComponent],
                    providers: [
                        provideNgxMask()
                    ]
                }]
        }] });

class FormularioVidaPerfilModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormularioVidaPerfilModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: FormularioVidaPerfilModule, declarations: [FormularioVidaPerfilComponent,
            TruncarPipe,
            CapitalizePipe], imports: [CommonModule,
            FormsModule,
            MatFormFieldModule,
            MatAutocompleteModule,
            MatIconModule,
            MatTooltipModule,
            NgxCurrencyDirective,
            MatInputModule,
            NgxMaskDirective,
            MatSelectModule,
            NgxMaskPipe,
            ReactiveFormsModule,
            MatChipsModule,
            MatProgressSpinnerModule], exports: [FormularioVidaPerfilComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormularioVidaPerfilModule, providers: [
            provideNgxMask()
        ], imports: [CommonModule,
            FormsModule,
            MatFormFieldModule,
            MatAutocompleteModule,
            MatIconModule,
            MatTooltipModule,
            MatInputModule,
            MatSelectModule,
            ReactiveFormsModule,
            MatChipsModule,
            MatProgressSpinnerModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormularioVidaPerfilModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        FormularioVidaPerfilComponent,
                        TruncarPipe,
                        CapitalizePipe
                    ],
                    imports: [
                        CommonModule,
                        FormsModule,
                        MatFormFieldModule,
                        MatAutocompleteModule,
                        MatIconModule,
                        MatTooltipModule,
                        NgxCurrencyDirective,
                        MatInputModule,
                        NgxMaskDirective,
                        MatSelectModule,
                        NgxMaskPipe,
                        ReactiveFormsModule,
                        MatChipsModule,
                        MatProgressSpinnerModule
                    ],
                    exports: [FormularioVidaPerfilComponent],
                    providers: [
                        provideNgxMask()
                    ]
                }]
        }] });

class FormularioVidaCoberturasModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormularioVidaCoberturasModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: FormularioVidaCoberturasModule, declarations: [FormularioVidaCoberturasComponent], imports: [CommonModule,
            FormsModule,
            MatFormFieldModule,
            MatIconModule,
            MatAutocompleteModule,
            MatSelectModule,
            MatInputModule,
            NgxMaskDirective,
            NgxMaskPipe,
            ReactiveFormsModule], exports: [FormularioVidaCoberturasComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormularioVidaCoberturasModule, providers: [
            provideNgxMask()
        ], imports: [CommonModule,
            FormsModule,
            MatFormFieldModule,
            MatIconModule,
            MatAutocompleteModule,
            MatSelectModule,
            MatInputModule,
            ReactiveFormsModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormularioVidaCoberturasModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FormularioVidaCoberturasComponent],
                    imports: [
                        CommonModule,
                        FormsModule,
                        MatFormFieldModule,
                        MatIconModule,
                        MatAutocompleteModule,
                        MatSelectModule,
                        MatInputModule,
                        NgxMaskDirective,
                        NgxMaskPipe,
                        ReactiveFormsModule,
                    ],
                    exports: [FormularioVidaCoberturasComponent],
                    providers: [
                        provideNgxMask()
                    ]
                }]
        }] });

class FormularioVidaVigenciaModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormularioVidaVigenciaModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: FormularioVidaVigenciaModule, declarations: [FormularioVidaVigenciaComponent], imports: [CommonModule,
            FormsModule,
            MatFormFieldModule,
            MatIconModule,
            MatInputModule,
            MatAutocompleteModule,
            MatSelectModule,
            NgxMaskDirective,
            NgxMaskPipe,
            ReactiveFormsModule], exports: [FormularioVidaVigenciaComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormularioVidaVigenciaModule, providers: [
            provideNgxMask()
        ], imports: [CommonModule,
            FormsModule,
            MatFormFieldModule,
            MatIconModule,
            MatInputModule,
            MatAutocompleteModule,
            MatSelectModule,
            ReactiveFormsModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormularioVidaVigenciaModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FormularioVidaVigenciaComponent],
                    imports: [
                        CommonModule,
                        FormsModule,
                        MatFormFieldModule,
                        MatIconModule,
                        MatInputModule,
                        MatAutocompleteModule,
                        MatSelectModule,
                        NgxMaskDirective,
                        NgxMaskPipe,
                        ReactiveFormsModule,
                    ],
                    exports: [FormularioVidaVigenciaComponent],
                    providers: [
                        provideNgxMask()
                    ]
                }]
        }] });

class LibFormularioVidaModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LibFormularioVidaModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: LibFormularioVidaModule, declarations: [
            // FormularioVidaPerfilComponent,
            // FormularioVidaCoberturasComponent,
            // FormularioVidaVigenciaComponent,
            LibFormularioVidaComponent,
            RemoveAriaOwnsDirective], imports: [CdkAccordionModule,
            CommonModule,
            FormsModule,
            MatAutocompleteModule,
            FormularioVidaSeguradoModule,
            FormularioVidaPerfilModule,
            FormularioVidaCoberturasModule,
            FormularioVidaVigenciaModule,
            MatButtonModule,
            MatCardModule,
            MatChipsModule,
            MatExpansionModule,
            MatFormFieldModule,
            MatIconModule,
            MatInputModule,
            MatProgressSpinnerModule,
            MatRadioModule,
            MatSelectModule,
            MatSnackBarModule,
            MatTooltipModule,
            NgxCurrencyDirective,
            ReactiveFormsModule,
            NgxMaskDirective,
            NgxMaskPipe], exports: [LibFormularioVidaComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LibFormularioVidaModule, providers: [
            FormsService,
            IconsService,
            provideNgxMask()
        ], imports: [CdkAccordionModule,
            CommonModule,
            FormsModule,
            MatAutocompleteModule,
            FormularioVidaSeguradoModule,
            FormularioVidaPerfilModule,
            FormularioVidaCoberturasModule,
            FormularioVidaVigenciaModule,
            MatButtonModule,
            MatCardModule,
            MatChipsModule,
            MatExpansionModule,
            MatFormFieldModule,
            MatIconModule,
            MatInputModule,
            MatProgressSpinnerModule,
            MatRadioModule,
            MatSelectModule,
            MatSnackBarModule,
            MatTooltipModule,
            ReactiveFormsModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LibFormularioVidaModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        // FormularioVidaPerfilComponent,
                        // FormularioVidaCoberturasComponent,
                        // FormularioVidaVigenciaComponent,
                        LibFormularioVidaComponent,
                        RemoveAriaOwnsDirective
                    ],
                    imports: [
                        CdkAccordionModule,
                        CommonModule,
                        FormsModule,
                        MatAutocompleteModule,
                        FormularioVidaSeguradoModule,
                        FormularioVidaPerfilModule,
                        FormularioVidaCoberturasModule,
                        FormularioVidaVigenciaModule,
                        MatButtonModule,
                        MatCardModule,
                        MatChipsModule,
                        MatExpansionModule,
                        MatFormFieldModule,
                        MatIconModule,
                        MatInputModule,
                        MatProgressSpinnerModule,
                        MatRadioModule,
                        MatSelectModule,
                        MatSnackBarModule,
                        MatTooltipModule,
                        NgxCurrencyDirective,
                        ReactiveFormsModule,
                        NgxMaskDirective,
                        NgxMaskPipe
                    ],
                    exports: [LibFormularioVidaComponent],
                    providers: [
                        FormsService,
                        IconsService,
                        provideNgxMask()
                    ]
                }]
        }] });

/*
 * Public API Surface of formulario-vida
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FormsService, LibFormularioVidaComponent, LibFormularioVidaModule };
